import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
// import "../catalog/catalog.scss";
import "./posscreen.scss";
import CustomerSearchModal from "../common/module/customerSearch";
import { Saleperson } from "../common/graphql/commonlayouts";
import CheckoutBlank from "../checkout/checkoutBlank";
import ParkHistoryButton from "../common/ParkHistoryButton";
import { _Api } from "../common/api/_call";
import CheckoutPayment from "./CheckoutPayment1";
import EmailModal, { openPosEmailModal } from "../common/Modals/EmailModal";
import Servicelabourmodal from "pos/common/Modals/Servicelabourmodal";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { clearFaroSessionsAfterCheckout, syncPosscreenFaroConfirmedFromCart } from "../catalog/faroSession";
import "../common/selectBox/select.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  toFormatPrice,
  toUnformatPrice,
  calculateTax,
} from "../common/helpers/function";
import Select from "react-select";
import { success, error, loading, Updateloading } from "../common/helpers/toastify";
import { updateCustomer, updateSaleperson } from "../../source/app/appSlice";
import { store } from "../../source/index";
import addressicon from "../../assets/images/pos/icons/script.png";
import AddCustomerAddressPopup from "../checkout/addCustomerPopup/AddCustomerAddressPopup";
import CustomerInformation from "../../admin/customers/customerInformation/CustomerInformation";
import notaddressicon from "../../assets/images/pos/icons/scriptnot.png";
import posplaceholderimage from "../../assets/images/posplaceholderimage.png";
import deleteiconimg from "../../assets/images/delete-img.png";
import faromainicon from "../../assets/images/faromainicon.svg";
import {
  buildLinkedOrderEntry,
  filterCartToRequestedLinkedLines,
  filterInStockSearchItems,
  filterLinkedSearchItems,
  hydrateLinkedOrdersFromCart,
  isCannotAddToCart,
  isSameLinkedOrderEntry,
  matchesLinkedOrderEntry,
} from "../common/helpers/linkedOrderPosscreen";

const Posscreen = () => {
  const location1 = useLocation();
  const state1 = location1.state?.state1 ? location1.state?.state1 : {};
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  let state = store.getState();

  const stateData = useSelector((state) => state.app.posState);

  const location = useLocation();
  const {

    parkid,
    order_id,
    order_type,
    order_edit,
    inv_orderid,
    inv_ordertype,
    by_customorder,
    by_repair_order,

    getproducts,
    setStockid,
    by_custom_order,
    mixmatchedit,
    reserve_status: stateReserveStatus,
    scrvicelistmixmatch,
  } = stateData;
  const ordertype = "pos_order";
  const [searchsku, setSearchsku] = useState();
  const [park_id, setpark_id] = useState();
  const [parkRefreshKey, setParkRefreshKey] = useState(0);
  const [toggleAddressCustomer, setToggleAddressCustomer] = useState(false);
  const [showcheckout, setShowcheckout] = useState("sell");
  const [showpayment, setShowpayment] = useState(false);
  const [TransactionDate, setTransactionDate] = useState(new Date());
  let checksale =
    localStorage.getItem("showcheckout") === "sell" ? true : false;
  const customer = useSelector((state) => state.app.customer);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  // const itemdaata = localStorage.getItem("itemdata")
  const [cartdetails, setCartdetails] = useState([]);
  const [UpdatedCart, setUpdatedCart] = useState();
  // const parsedObject = JSON.parse(itemdaata);
  const [cusid, setCusid] = useState();
  const [showorder, setShoworder] = useState(false);
  const [otpnumber, setOtpnumber] = useState([]);
  const [checkoutdetails, setcheckoutdetails] = useState();
  const [uuid, setUuid] = useState("");
  const [parksentence, setParksentence] = useState("");
  const [parkSaving, setParkSaving] = useState(false);
  const parkSavingRef = useRef(false);
  const [quatesentence, setQuatesentence] = useState("");
  const [showParkSuggestion, setShowParkSuggestion] = useState(false);
  const parkSuggestions = [
    "Hold for 30 minutes",
    "Parked until customer is ready",
    "Resume after customer confirmation",
    "Manager approval",
  ];
  const [loader, setLoader] = useState(false);
  const [deletecartids, setDeletecartids] = useState([]);
  const [searchlist, setSearchlist] = useState([]);
  const [linkedOrderIds, setLinkedOrderIds] = useState(
    Array.isArray(state1?.order_id) ? [...state1.order_id] : []
  );
  // A reserved item added here is being sold, same as "sale" from the Reserve list (reserve_status 0):
  // otherwise the reserve's own deposit % (e.g. 10) is saved on the sale.
  const reserve_status =
    stateReserveStatus ??
    (linkedOrderIds.some((entry) => entry?.reserve_sell) ? 0 : undefined);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [cartdelete, setCartdelete] = useState();
  const [service_enable, setService_enable] = useState(false);
  const [scrviceremark, setScrviceremark] = useState("");
  const [service_saved, setService_saved] = useState(false);
  const [servicelabourlist, setServicelabourlist] = useState([]);
  const [showmodal, setShowmodal] = useState(false);
  const [scrvicelist, setScrvicelist] = useState([]);
  const [editservicelaboure, setEditservicelaboure] = useState([]);
  const [scrviceedit, setScrviceedit] = useState(false);
  const [scrvicecharge, setScrvicecharge] = useState();
  const [cart_id, setCart_id] = useState();
  const [product_price, setProduct_price] = useState();
  const [oldorderid, setOldorderid] = useState();
  const [discountedCartItems, setDiscountedCartItems] = useState([]);
  const [orderPreserve, setOrderPreserve] = useState([]);
  const status_type = cartdetails?.length ? cartdetails[0]?.type : "";
  const searchDebounceRef = useRef(null);
  let OrgSettings = state?.app?.posorganisation_settings;
  const isFaroActive = OrgSettings?.faro_active === 1;
  const handleFaroClick = (e) => {
    if (!isFaroActive) {
      e.preventDefault();
      error(t("Please activate Claude and Voyage both in Settings > Integrated Applications"));
    }
  };
  const generalsettings = useSelector((state) => state.app.generalsettings);
  const [taxes, setTaxes] = useState({
    prect: UpdatedCart?.sell_info?.summary_order?.tax_prect
      ? UpdatedCart?.sell_info?.summary_order?.tax_prect
      : 0,
    amount: UpdatedCart?.sell_info?.summary_order?.tax_amount
      ? UpdatedCart?.sell_info?.summary_order?.tax_amount
      : 0,
    type: UpdatedCart?.sell_info?.summary_order?.tax_type
      ? UpdatedCart?.sell_info?.summary_order?.tax_type
      : "",
    taxintamount: UpdatedCart?.sell_info?.summary_order?.tax_amount_int
      ? UpdatedCart?.sell_info?.summary_order?.tax_amount_int
      : 0,
  });
  const [discount, setDiscount] = useState({
    prect: UpdatedCart?.sell_info?.summary_order?.discount_percent
      ? UpdatedCart?.sell_info?.summary_order?.discount_percent
      : 0,
    amount: UpdatedCart?.sell_info?.summary_order?.discount
      ? UpdatedCart?.sell_info?.summary_order?.discount
      : 0,
  });
  const [pricelabour, setPricelabour] = useState(
    parseFloat(
      UpdatedCart?.sell_info?.summary_order?.labour
        ? UpdatedCart?.sell_info?.summary_order?.labour
        : 0
    )
  );
  const [priceshipping, setPriceshipping] = useState(
    UpdatedCart?.sell_info?.summary_order?.shipping
      ? UpdatedCart?.sell_info?.summary_order?.shipping
      : 0
  );
  const [priceloyality, setPriceloyality] = useState(
    UpdatedCart?.sell_info?.summary_order?.loyality_points
      ? UpdatedCart?.sell_info?.summary_order?.loyality_points
      : 0
  );
  const [depositprect, setDepositprect] = useState({
    label: UpdatedCart?.sell_info?.summary_order?.deposit
      ? UpdatedCart?.sell_info?.summary_order?.deposit + "%"
      : cartdetails?.length
        ? cartdetails[0]?.type === "pos_order" ||
          cartdetails[0]?.type === "gift_card_order" ||
          cartdetails[0]?.type === "deposit"
          ? "0%"
          : "10%"
        : "10%",
    value: UpdatedCart?.sell_info?.summary_order?.deposit
      ? UpdatedCart?.sell_info?.summary_order?.deposit
      : cartdetails?.length
        ? cartdetails[0]?.type === "pos_order" ||
          cartdetails[0]?.type === "gift_card_order" ||
          cartdetails[0]?.type === "deposit"
          ? 0
          : 10
        : 10,
  });

  const hasFetchedCartRef = useRef(false);
  const linkedOrderIdsRef = useRef(linkedOrderIds);
  const cartdetailsRef = useRef(cartdetails);
  const [orderCount, setOrderCount] = useState(0);
  useEffect(() => {
    linkedOrderIdsRef.current = linkedOrderIds;
  }, [linkedOrderIds]);
  useEffect(() => {
    cartdetailsRef.current = cartdetails;
  }, [cartdetails]);
  useEffect(() => {
    if (!Array.isArray(state1?.order_id) || !state1.order_id.length) {
      return;
    }
    setLinkedOrderIds((current) => (current.length ? current : [...state1.order_id]));
  }, [state1?.order_id]);
  const generateUuid = () => {
    const newUuid = crypto.randomUUID();
    setUuid(newUuid);
  };
  let mainstatustype = cartdetails?.length ? cartdetails[0]?.type : "";
  const edit = (cart_id) => {
    let carts = [...cartdetails];
    let esditservicearray = [...editservicelaboure];
    carts.forEach((result) => {
      if (result?.custom_cart_id === cart_id) {
        result.service_labour = {
          product_price: product_price,
          service_remark: scrviceremark,
          service_laburelist: scrvicelist,
          cart_id: result?.custom_cart_id,
          totalscrviceamount: scrvicecharge,
        };
        if (esditservicearray?.length && scrviceedit) {
          esditservicearray.forEach((index) => {
            index.service_labour = { ...result.service_labour };
          });
        } else {
          result.Service_labour_exsist = true;
          esditservicearray.push(result.service_labour);

          let total = esditservicearray.reduce((acc, curr) => {
            return acc + (curr?.totalscrviceamount || 0);
          }, 0);

          setPricelabour(total);
        }
        result.Service_labour = result.service_labour;
        delete result.service_labour;
      }
    });
    setEditservicelaboure(esditservicearray);
  };
  // const getsearchcatalog = async (search) => {
  //   search = search ? search.trim() : "";
  //   if (!search) {
  //     setSearchlist([]);
  //     return;
  //   }
  //   try {
  //     const postdata = {
  //       stock_id: search,
  //     };
  //     let res = await _Api(postdata, `api/v1/POS/home/inStockItems`);
  //     if (res.code === 200) {
  //       // generateUuid();
  //       setSearchlist(res?.data?.data);
  //       setShowDropdown(true);
        
  //     } else {
  //       setSearchlist([]);
  //       setShowDropdown(false);
  //     }
  //   } catch (err) {
  //     console.log(err, "err");
  //   }
  // };

  const getsearchcatalog = async (search) => {
    search = search ? search.trim() : "";
  
    if (!search) {
      setSearchlist([]);
      setShowDropdown(false);
      return;
    }
  
    try {
      const cart = cartdetailsRef.current || [];
      const linkedOrders = linkedOrderIdsRef.current || [];
      const stockPromise = _Api(
        { stock_id: search },
        `api/v1/POS/home/inStockItems`
      ).catch((err) => {
        console.log(err, "inStockItems");
        return null;
      });
      const linkedPromise = customer?.id
        ? _Api(
            { search, customer_id: customer.id },
            `api/v1/POS/customOrder/getLinkedItemsByCustomer`
          ).catch((err) => {
            console.log(err, "getLinkedItemsByCustomer");
            return null;
          })
        : Promise.resolve(null);

      const [stockRes, linkedRes] = await Promise.all([stockPromise, linkedPromise]);
      const stockItems =
        stockRes?.code === 200 ? stockRes?.data?.data || [] : [];
      const filteredStock = filterInStockSearchItems(stockItems, cart);

      let linkedItems = [];
      if (linkedRes?.code === 200) {
        linkedItems = filterLinkedSearchItems(
          Array.isArray(linkedRes?.data) ? linkedRes.data : [],
          cart,
          linkedOrders
        );
      }

      const linkedStockIds = new Set(
        linkedItems.map((item) => String(item?.stock_id || "")).filter(Boolean)
      );
      const filteredStockWithoutLinked = filteredStock.filter(
        (item) => !item?.stock_id || !linkedStockIds.has(String(item.stock_id))
      );
      const merged = [...linkedItems, ...filteredStockWithoutLinked];
      setSearchlist(merged);
      setShowDropdown(merged.length > 0);
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getOrderCount = async () => {
    try {
      const postdata = {
        customer_id: customer?.id ? customer?.id : false,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/customOrderCount`);
      if (res.code === 200) {
        setOrderCount(res?.counts?.total_orders);
      } else {
        setOrderCount(0);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const GetCartdetail = async (order_edit, order_type, order_id, deletecartidsParam = deletecartids, withOrder, recallPark = false) => {
    const resolvedOrderId = Array.isArray(order_id)
      ? order_id
      : (linkedOrderIdsRef.current?.length
          ? linkedOrderIdsRef.current
          : (inv_orderid ? inv_orderid : order_id));
    const hasLinkedOrders =
      Array.isArray(resolvedOrderId) && resolvedOrderId.length > 0;
    const resolvedOrderType =
      inv_ordertype ||
      order_type ||
      resolvedOrderId?.[resolvedOrderId.length - 1]?.order_type;
    try {
      const postdata = {
        mixmatchedit: mixmatchedit,
        order_type: resolvedOrderType,
        order_edit: order_edit,
        order_id: resolvedOrderId,
        by_custom_order: state1?.by_custom_order,
        withOrder: Boolean(withOrder) || hasLinkedOrders,
        ...(recallPark ? { recall_park: true } : {}),
      };
      setCartdetails([]);
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        if (res?.data?.sell_info) {
          // await setUpdatedCart(res?.data);
          // setCartdetails(UpdatedCart?.sell_info?.cart);
          // dispatch(updateCustomer(UpdatedCart?.sell_info?.summary_order?.customer_id));
          // dispatch(updateSaleperson(UpdatedCart?.sell_info?.summary_order?.sales_person_id));
          // let jsondata = JSON.stringify(UpdatedCart?.sell_info?.summary_order?.sales_person_id);
          // localStorage.setItem('salesdetails', jsondata);
          const updatedData = res.data;
          let cart = updatedData?.sell_info?.cart || [];

          // ✅ keep only items NOT in deletecartids
          cart = cart.filter(
            (item) => !deletecartidsParam.includes(item?.custom_cart_id)
          );
          const sourceOrders = Array.isArray(resolvedOrderId)
            ? resolvedOrderId
            : linkedOrderIdsRef.current;
          const hydratedOrders = hydrateLinkedOrdersFromCart(sourceOrders, cart);
          linkedOrderIdsRef.current = hydratedOrders;
          setLinkedOrderIds(hydratedOrders);
          cart = filterCartToRequestedLinkedLines(cart, hydratedOrders);
           if (discountedCartItems?.length) {
            cart = cart.map((item) => {
              const existing = discountedCartItems.find(
                (p) => p.custom_cart_id === item.custom_cart_id
              );
              return existing
                ? {
                  ...item,
                  ...existing,
                  Service_labour: item?.Service_labour,
                  Service_labour_exsist: item?.Service_labour_exsist,
                  service_labour_exsist: item?.service_labour_exsist,
                  Service_labour_total_charges:
                    item?.Service_labour_total_charges,
                }
                : item;
            });
          }
          // Later fetches return no saved discount, so keep the recalled ones like typed ones.
          if (recallPark && cart.some((item) => Number(item?.Discount_Amount) > 0)) {
            setDiscountedCartItems(cart);
          }
          setUpdatedCart({
            ...updatedData,
            sell_info: {
              ...updatedData.sell_info,
              summary_order: {
                ...(updatedData.sell_info?.summary_order || {}),
                checkOutAmount: null,
              },
            },
          });
          setCartdetails(cart);
          syncPosscreenFaroConfirmedFromCart(cart);
          // dispatch(
          //   updateCustomer(updatedData?.sell_info?.summary_order?.customer_id)
          // );
          if (updatedData?.sell_info?.summary_order?.sales_person_id?.value) {
            dispatch(
              updateSaleperson(
                updatedData?.sell_info?.summary_order?.sales_person_id
              )
            );
            localStorage.setItem(
              "salesdetails",
              JSON.stringify(
                updatedData?.sell_info?.summary_order?.sales_person_id
              )
            );
          }
          // Keep POS tax/discount/deposit; order summary is for linked orders only.
            let total = 0;
          for (var i = 0; i < cart?.length; i++) {
            if (cart[i]?.Service_labour_total_charges) {
              total = total + cart[i].Service_labour_total_charges;
            }
            setPricelabour(total);
          }
           setSearchlist([]);
          // setToggleAddressCustomer(false);
        } else {
          let updatedCart = res?.data || [];
          updatedCart = updatedCart.filter(
            (item) => !deletecartidsParam.includes(item?.custom_cart_id)
          );
          const sourceOrders = Array.isArray(resolvedOrderId)
            ? resolvedOrderId
            : linkedOrderIdsRef.current;
          const hydratedOrders = hydrateLinkedOrdersFromCart(
            sourceOrders,
            updatedCart
          );
          linkedOrderIdsRef.current = hydratedOrders;
          setLinkedOrderIds(hydratedOrders);

          // ✅ merge discounts if exist
          if (discountedCartItems?.length) {
            updatedCart = updatedCart.map((item) => {
              const existing = discountedCartItems.find(
                (p) => p.stock_id === item.stock_id
              );
              return existing
                ? {
                  ...item,
                  ...existing,
                  Service_labour: item?.Service_labour,
                  Service_labour_exsist: item?.Service_labour_exsist,
                  service_labour_exsist: item?.service_labour_exsist,
                  Service_labour_total_charges:
                    item?.Service_labour_total_charges,
                }
                : item;
            });
          }

          // ✅ reorder according to orderPreserve
          if (orderPreserve?.length) {
            updatedCart.sort((a, b) => {
              const aIndex = orderPreserve.indexOf(a.stock_id);
              const bIndex = orderPreserve.indexOf(b.stock_id);

              // items not found in orderPreserve go to the end
              if (aIndex === -1 && bIndex === -1) return 0;
              if (aIndex === -1) return 1;
              if (bIndex === -1) return -1;

              return aIndex - bIndex;
            });
          }

          setCartdetails(updatedCart);
          syncPosscreenFaroConfirmedFromCart(updatedCart);
          setSearchlist([]);

          let total = 0;
          for (var i = 0; i < res?.data?.length; i++) {
            if (res?.data[i]?.Service_labour_total_charges) {
              total = total + res?.data[i].Service_labour_total_charges;
            }
            setPricelabour(total);
          }

          if (res?.data?.sell_info?.cart?.length) {
            res?.data?.sell_info?.cart?.forEach((result, key) => {
              setService_enable(result?.Service_labour_exsist);
            });
          }
        }
      } else {
        navigate("/app/pos/custom/createYourOwn");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const refreshCartFromLinkedOrders = (nextLinked, deleteIds = deletecartids, recallPark = false) => {
    if (nextLinked?.length) {
      const lastType = nextLinked[nextLinked.length - 1]?.order_type || state1?.order_type;
      return GetCartdetail(order_edit, lastType, nextLinked, deleteIds, true, recallPark);
    }
    return GetCartdetail(order_edit, undefined, [], deleteIds, true, recallPark);
  };
  const handleSearchItemClick = (result) => {
    if (result?.linked_order_id) {
      const entry = {
        ...(buildLinkedOrderEntry(result) || {}),
        id: result.linked_order_id,
        order_type: result.order_type || result.status_type,
        linked_cart_id: result.linked_cart_id,
        stock_id: result.stock_id,
        po_product_id: result.po_product_id,
      };
      if (entry.order_type === "custom_order") entry.by_custom_order = true;
      if (entry.order_type === "repair_order") entry.by_repair_order = true;
      if (entry.order_type === "reserve") entry.reserve_sell = true;
      if (isCannotAddToCart(result)) {
        entry.collect_at_holding_location = true;
      }
      const current = linkedOrderIdsRef.current || [];
      const exists = current.some((item) => isSameLinkedOrderEntry(item, entry));
      const next = exists ? current : [...current, entry];
      setLinkedOrderIds(next);
      refreshCartFromLinkedOrders(next);
      setShowDropdown(false);
      return;
    }
    AddtoCart(result?._id, result?.order_id ? result?.order_id : "", result?.stock_id ? result?.stock_id : "");
    setShowDropdown(false);
  };
  const [isSummaryActive, setIsSummaryActive] = useState(false);

  const summaryToggle = (event) => {
    setIsSummaryActive((current) => !current);
  };
  const changeTax = (lable, taxvalue) => {
    let type = OrgSettings?.tax?.type;
    let value = taxvalue ? parseFloat(taxvalue) : "";
    let sub_totalAmount = cartdetails?.length
      ? cartdetails.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * parseInt(val?.price)),
        0
      ) +
      parseInt(pricelabour + priceshipping + priceloyality - discount?.amount)
      : 0;
    if (
      ordertype === "deposit" 
    ) {
      setTaxes({
        prect: 0,
        amount: 0,
        type: "",
        taxintamount: 0,
      });
    } else {
      if (lable === "default" || lable === "taxprecent") {
        if (type === "Inclusive") {
          let TaxAmounts = (value * sub_totalAmount) / (100 + value);
          setTaxes({
            prect: value ? value : 0,
            amount: parseFloat(TaxAmounts).toFixed(2),
            type: "Inclusive",
            taxintamount: parseFloat(TaxAmounts),
          });
        } else if (type === "Exclusive") {
          let TaxAmounts = (value * sub_totalAmount) / 100;
          setTaxes({
            prect: value ? value : 0,
            amount: parseFloat(TaxAmounts).toFixed(2),
            type: "Exclusive",
            taxintamount: parseFloat(TaxAmounts),
          });
        }
      }
    }
  };
  const depositoptionarray = [
    {
      label: "0%",
      value: 0,
    },
    {
      label: "10%",
      value: 10,
    },
    {
      label: "25%",
      value: 25,
    },
    {
      label: "50%",
      value: 50,
    },
    {
      label: "75%",
      value: 75,
    },
    {
      label: "100%",
      value: 100,
    },
  ];
  // useEffect(() => {

  //   if (UpdatedCart !== undefined) {
  //     // dispatch(updateCustomer(UpdatedCart?.sell_info?.summary_order?.customer_id));
  //     dispatch(updateSaleperson(UpdatedCart?.sell_info?.summary_order?.sales_person_id));
  //     let jsondata = JSON.stringify(UpdatedCart?.sell_info?.summary_order?.sales_person_id);
  //     localStorage.setItem('salesdetails', jsondata);
  //     setsearchproductstatus(false);
  //     setCartdetails(UpdatedCart?.sell_info?.cart);
  //   } else {
  //     if (order_edit && order_type && order_id) {
  //       GetCartdetail(order_edit, order_type, order_id)
  //       setCartdetails(UpdatedCart?.sell_info?.cart);
  //     } else {
  //       if (customsecrive) {
  //         setService_enable(true)
  //       }
  //       if (searchproductstatus) {
  //         GetCartdetail()
  //       }
  //     }
  //   }

  //   // eslint-disable-next-line
  // }, [searchproductstatus, customsecrive, UpdatedCart])
  useEffect(() => {
    if (customer?.id) getOrderCount();
    else getOrderCount();
  }, [customer?.id]);

  useEffect(() => {
    if (!hasFetchedCartRef.current) {
      hasFetchedCartRef.current = true;
      if (state1?.parkId) return;

      GetCartdetail(
        order_edit,
        state1?.order_type,
        state1?.order_id,
        deletecartids,
        state1?.withOrder
      );
    }
  }, [customer, state1?.order_id]);
  const editcustomer = async (order_id) => {
    try {
      let postdata = {
        order_id: state1?.order_id
      }
      let res = await _Api(postdata, `api/v1/pos/customOrder/edit-details`)
      if (res?.code === 200) {
        let customerdata = { id: res?.data?.customer_id, name: res?.data?.name, existsInAddress: true }
        dispatch(updateCustomer(customerdata));
        let jsondata = JSON.stringify(customerdata);
        localStorage.setItem('customerdetails', jsondata);
        let lastobj = { billing_address: res?.data?.billing_address, shipping_address: res?.data?.shipping_address }
        let data = JSON.stringify(lastobj);
        localStorage.setItem('addcustomerdtaa', data);

      } else {
        error((res?.message))
      }
    }
    catch (err) {
      console.log(err, "Err")
    }
  }
  useEffect(() => {
    if (state1?.order_id?.length) {
      editcustomer(order_id)
    }
    // eslint-disable-next-line
  }, [state1?.order_id])

  // lines brought in from a linked order (reserve / custom / repair) keep the order's quantity
  const isLinkedCartLine = (line) => Boolean(line?.linked_order_id);
  const changeQty = (i, label, po_QTY) => {
    let array = [...cartdetails];
    if (isLinkedCartLine(array[i])) return;
    if (label === "add") {
      if (ordertype === "custom_order") {
        array[i] = {
          ...array[i],
          Qty: array[i]["Qty"] ? array[i]["Qty"] + 1 : array[i]["Qty"],
        };
      } else if (ordertype === "repair_order" || ordertype === "refund_order") {
        array[i] = {
          ...array[i],
          Qty: po_QTY > array[i]["Qty"] ? array[i]["Qty"] + 1 : array[i]["Qty"],
        };
      } else {
        array[i] = {
          ...array[i],
          Qty: po_QTY > array[i]["Qty"] ? array[i]["Qty"] + 1 : array[i]["Qty"],
        };
      }
    } else {
      if (array[i]["Qty"] > 1) {
        array[i] = {
          ...array[i],
          Qty: array[i]["Qty"] - 1,
        };
      }
    }
    setCartdetails(array);
  };
  const parts = location.pathname.split("/");
  const checkstockid = async (oldstockid, newstockid, custom_cart_id, qty) => {
    try {
      let postdata = {
        old_stockId: oldstockid ? oldstockid : "",
        new_stockId: newstockid ? newstockid : "",
        cart_id: custom_cart_id ? custom_cart_id : "",
        qty: qty ? qty : "",
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/stockIdManage`);
      if (res?.code === 200) {
        success("Stockid Updated");
        refreshCartFromLinkedOrders(linkedOrderIdsRef.current);
        if (parts[3] === "products" && parts?.length === 4) {
          getproducts();
        }
      } else {
        error("Somthing Went Wrong");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  // const scrollableDivRef = useRef(null); // Reference to the scrollable div
  // const [hasReachedEnd, setHasReachedEnd] = useState(false);

  // const handleScroll = () => {
  //     if (shoremorelodar) return;

  //     const div = scrollableDivRef.current;
  //     if (div) {
  //         const { scrollTop, scrollHeight, clientHeight } = div;
  //         const CompleteScroll = (scrollTop + clientHeight);

  //         // Check if the user has scrolled to the bottom
  //         // console.log(CompleteScroll >= (scrollHeight - 10), "<<<<", CompleteScroll, (scrollHeight - 10));
  //         // console.log(hasReachedEnd, "FFFFFF", shoremorelodar);

  //         if (CompleteScroll >= (scrollHeight - 5)) {
  //             if (!hasReachedEnd) {
  //                 if (finalprodata?.length !== 0 && (skip + 20) <= Totalproduct && shoremorelodar === false) {
  //                     setHasReachedEnd(true);
  //                     setSkip(prevSkip => {
  //                         const newSkip = prevSkip + 20;
  //                         return newSkip;
  //                     });
  //                     setShowmorelodar(prevSkip => prevSkip ? false : true);

  //                 }
  //             }
  //         } else {
  //             setHasReachedEnd(false);
  //             setShowmorelodar(false)
  //             // Reset when not at the bottom
  //         }
  //     }
  // }
  // useEffect(() => {
  //     getproducts();
  //     // eslint-disable-next-line
  // }, [skip, Sale, isCrown, customer?.id]);
  const deletecart = async (
    cartid,
    transaction_type,
    amount,
    sessioncartid,
    stock_id
  ) => {
    if (
      (ordertype === "exchange_order" ||
        ordertype === "refund_order" ||
        ordertype === "Quotation") &&
      !order_edit
    ) {
      setCartdetails((current) => {
        const next = current.filter((item) => item?.custom_cart_id !== cartid);
        syncPosscreenFaroConfirmedFromCart(next);
        return next;
      });
      setOrderPreserve((current) =>
        current.filter((item) => item !== stock_id)
      );
      setShowcheckout("blank");
    } else {
      try {
        const postdata = {
          custom_cart_id: cartid,
          customer_id: customer?.id ? customer?.id : "",
          park_id: parkid,
        };
        let res = await _Api(postdata, `api/v1/POS/customOrder/deleteCartItem`);
        if (res.code === 200) {
          const foundItem =
            cartdetails.find((item) => item?.custom_cart_id === cartid) ||
            cartdetailsRef.current.find((item) => item?.custom_cart_id === cartid);
          const deletedItem = {
            ...(foundItem || {}),
            custom_cart_id: cartid,
            stock_id: foundItem?.stock_id || stock_id,
          };
          const nextLinked = (linkedOrderIdsRef.current || []).filter(
            (entry) => !matchesLinkedOrderEntry(entry, deletedItem)
          );
          const removedLinked =
            nextLinked.length !== (linkedOrderIdsRef.current || []).length;
          if (removedLinked) {
            setLinkedOrderIds(nextLinked);
          }
          let newDeleteCartIds = deletecartids;
          if (!removedLinked && !deletecartids.includes(cartid)) {
            newDeleteCartIds = [...deletecartids, cartid];
            setDeletecartids(newDeleteCartIds);
          }
          if (ordertype !== "exchange_order" && ordertype !== "refund_order") {
            refreshCartFromLinkedOrders(nextLinked, newDeleteCartIds);
          }
          if (cartdetails?.length === 1) {
            // setShowcheckout("blank");
          } else if (ordertype === "reserve") {
            if (cartdetails.length) {
              cartdetails.forEach((result, key) => {
                if (cartid === result?.custom_cart_id) {
                  setStockid(result?.stock_id);
                }
              });
            }
          }
        }
      } catch (err) {
        console.log(err, "err");
      }
    }
  };
  const changeprice = (i, value, name, qty) => {
    let array = [...cartdetails];
    let price = array[i]["retailprice_Inc"];
    if (name === "price") {
      array[i]["discount_percent"] = Number(
        (((price - value) / price) * 100).toFixed(2)
      );
      array[i]["Discount_Amount"] = price - value;
      array[i] = {
        ...array[i],
        [name]: value,
      };
    } else if (name === "stock_id") {
      array[i]["po_QTY"] = qty;
    } else if (name === "delivery_date") {
      if (value.getTime() >= new Date().getTime()) {
        array[i]["delivery_date"] = new Date(value);
      }
    }

    setCartdetails(array);
  };
  const selectTransactionDate = (input) => {
    setTransactionDate(input);
  };
  const changediscount = (lable, value) => {
    let total = cartdetails?.length
      ? cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * parseFloat(val?.price)),
        0
      )
      : 0;
    if (lable === "discountprecent") {
      let precent = (total * value) / 100;
      setDiscount((existingValues) => ({
        ...existingValues,
        prect: parseFloat(value * 100) / 100,
      }));
      setDiscount((existingValues) => ({ ...existingValues, amount: precent }));
    } else if (lable === "discountamount") {
      let amount = (value / total) * 100;
      setDiscount((existingValues) => ({
        ...existingValues,
        prect: parseFloat((amount * 100).toFixed(2)) / 100,
      }));
      setDiscount((existingValues) => ({ ...existingValues, amount: value }));
    } else {
      let precent = (discount?.amount * 100) / total;
      let amount = discount?.amount;
      setDiscount((existingValues) => ({
        ...existingValues,
        prect: parseFloat(precent),
      }));
      setDiscount((existingValues) => ({ ...existingValues, amount: amount }));
    }
  };
  const changecartdiscount = (value, key, lable) => {
    let array = [...cartdetails];
    let price = array[key]["retailprice_Inc"];
    if (lable === "discountprecent") {
      if (value <= 100) {
        let precent = (price * value) / 100;
        let finalprice = price - precent;
        array[key] = {
          ...array[key],
          discount_percent: Math.floor(value * 100) / 100,
          Discount_Amount: precent,
          price: finalprice,
        };
        setCartdetails(array);
        setDiscountedCartItems(array);
      } else {
        error(t("Discount Tax should be less than 100"));
        return;
      }
    } else {
      if (value <= price) {
        let amount = (value / price) * 100;
        let finalprice = price - value;
        array[key] = {
          ...array[key],
          discount_percent: Math.floor(amount * 100) / 100,
          Discount_Amount: value,
          price: finalprice,
        };
        setCartdetails(array);
        setDiscountedCartItems(array);
      } else {
        error(t("Discount Amount should be less than") + price);
        return;
      }
    }
  };
  const addclasstocart = (key) => {
    let array = [...cartdetails];
    if (array[key]?.addclass) {
      array[key] = { ...array[key], addclass: false };
    } else {
      array[key] = { ...array[key], addclass: true };
    }
    setCartdetails(array);
  };
  const callpaymentcheckout = async () => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    // if (!saleperson?.value) {
    //   error(t("SalePerson is Requried!!"));
    //   return;
    // }
    let carts = [...cartdetails];

    let deposit_details = { cash: 0, credit_card: 0, bank: 0 };
    if (ordertype === "deposit") {
      let allcash = 0;
      let allcreditcard = 0;
      let allbank = 0;
      if (carts?.length) {
        carts.forEach((result) => {
          if (result?.transaction_type === "cash") {
            allcash = parseFloat(allcash) + parseFloat(result?.price);
          }
          if (result?.transaction_type === "creditcard") {
            allcreditcard =
              parseFloat(allcreditcard) + parseFloat(result?.price);
          }
          if (result?.transaction_type === "bank") {
            allbank = parseFloat(allbank) + parseFloat(result?.price);
          }
        });
      }
      deposit_details = {
        cash: allcash,
        credit_card: allcreditcard,
        bank: allbank,
      };
    }

    let totalamount =
      ordertype === "repair_order"
        ? cartdetails?.reduce(
          (interation, val) =>
            parseFloat((interation = interation + val?.price)),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )
        : cartdetails?.reduce(
          (interation, val) =>
            (interation = interation + parseFloat(val.Qty) * val?.price),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        );
    let depositamount =
      ordertype === "repair_order"
        ? (cartdetails?.reduce(
          (interation, val) =>
            (interation = interation + toUnformatPrice(val?.price)),
          0
        ) +
          parseFloat(
            pricelabour +
            priceshipping +
            priceloyality -
            discount?.amount +
            (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
          )) *
        (depositprect?.value / 100)
        : (cartdetails?.reduce(
          (interation, val) =>
          (interation =
            interation + parseFloat(val.Qty) * toUnformatPrice(val?.price)),
          0
        ) +
          parseFloat(
            pricelabour +
            priceshipping +
            priceloyality -
            discount?.amount +
            (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
          )) *
        (depositprect?.value / 100);
    let subtotal =
      ordertype === "repair_order"
        ? cartdetails?.reduce(
          (interation, val) =>
            (interation = interation + toUnformatPrice(val?.price)),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount -
          (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
        )
        : cartdetails?.reduce(
          (interation, val) =>
          (interation =
            interation + parseFloat(val.Qty) * toUnformatPrice(val?.price)),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount -
          (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
        );

    let summaryorder = {
      labour: pricelabour,
      shipping: priceshipping,
      loyality_points: priceloyality,
      customer_id: customer,
      sales_person_id: saleperson,
      discount: discount?.amount,
      discount_percent: discount?.prect,
      deposit:
        status_type === "pos_order" ||
          ordertype === "gift_card_order" ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? 0
          : depositprect?.value,
      deposit_amount:
        status_type === "pos_order" ||
          ordertype === " " ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? 0
          : depositamount,
      tax_amount: taxes?.amount,
      tax_amount_int: taxes?.taxintamount,
      tax_prect: taxes?.prect,
      tax_type: taxes?.type,
      Sub_Total: subtotal,
    };
    try {
      const postdata = {};
      const credit_notepostdata = {
        customer_id: customer?.id,
      };
      let res = await _Api(
        postdata,
        `api/v1/POS/checkout/payment/getCashMethodList`
      );
      let res_credit_note = await _Api(
        credit_notepostdata,
        `api/v1/POS/checkout/creditnote/getCreditNote`
      );
      if (res.code === 200) {
        setUpdatedCart({
          sell_info: {
            cart: carts,
            deletecart_ids: deletecartids,
            summary_order: summaryorder,
            status_type:
              reserve_status === 0
                ? "pos_order"
                : status_type
                  ? status_type
                  : mainstatustype
                    ? mainstatustype
                    : ordertype,
            totalamount: parseFloat(totalamount),
            park_id: parkid,
            order_id: linkedOrderIdsRef.current?.length
              ? linkedOrderIdsRef.current
              : order_id,
            service_labour: editservicelaboure,
            old_custom_order_id: oldorderid,
          },
          service_enable: service_enable,

          totalamount:
            status_type === "pos_order" ||
              ordertype === "gift_card_order" ||
              ordertype === "deposit" ||
              reserve_status === 0
              ? totalamount
              : totalamount,
          ordertype: ordertype,
          deposit_details: ordertype === "deposit" ? deposit_details : "",
          payment_Options: res?.data,
          credit_note_options: res_credit_note?.data,
          oldcredit_note_options: res_credit_note?.data,
        });
        setShowcheckout("payment");
        setShowpayment(true);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const callpark = async () => {
    // A ref as well as state: state only changes after a render, too late for a double click.
    if (parkSavingRef.current) return;
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    let carts = [...cartdetails];
    let totalamount =
      cartdetails?.reduce(
        (interation, val) =>
          (interation = interation + parseInt(val.Qty) * val?.price),
        0
      ) +
      parseFloat(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount +
        (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
      );

    let depositamount =
      (cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )) *
      (depositprect?.value / 100);
    let subtotal =
      cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
      parseFloat(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount -
        (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
      );

    let summaryorder = {
      labour: pricelabour,
      shipping: priceshipping,
      loyality_points: priceloyality,
      customer_id: customer,
      sales_person_id: saleperson,
      discount: discount?.amount,
      discount_percent: discount?.prect,
      deposit:
        status_type === "pos_order" ||
          ordertype === "gift_card_order" ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? "0"
          : depositprect?.value,
      deposit_amount:
        status_type === "pos_order" ||
          ordertype === "gift_card_order" ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? "0"
          : depositamount,
      tax_amount: taxes?.amount,
      tax_amount_int: taxes?.taxintamount,
      tax_prect: taxes?.prect,
      tax_type: taxes?.type,
      Sub_Total: subtotal,
    };
    try {
      const postdata = {
        sell_info: {
          cart: carts,
          summary_order: summaryorder,
          status_type: status_type
            ? status_type
            : mainstatustype
              ? mainstatustype
              : ordertype,
          totalamount: totalamount,
        },
        customer_id: customer?.id ? customer?.id : "",
        sales_person_id: saleperson?.value ? saleperson?.value : "",
        totalamount:
          status_type === "pos_order" ||
            ordertype === "gift_card_order" ||
            ordertype === "deposit" ||
            reserve_status === 0
            ? totalamount
            : parseFloat(depositamount),
        parktime: parksentence,
      };
      parkSavingRef.current = true;
      setParkSaving(true);
      let res = await _Api(postdata, `api/v1/POS/park/savepark`);
      if (res.code === 200) {
        setShowcheckout("blank");
        setCartdetails([]);
        setUpdatedCart([]);
        // These lines left with the park; recallPark brings them back.
        linkedOrderIdsRef.current = [];
        setLinkedOrderIds([]);
        setParksentence("");
        syncPosscreenFaroConfirmedFromCart([]);
      } else {
        error(res?.message);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      parkSavingRef.current = false;
      setParkSaving(false);
    }
  };
  const savequte = async () => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    let carts = [...cartdetails];
    let totalamount =
      cartdetails?.reduce(
        (interation, val) =>
          (interation = interation + parseInt(val.Qty) * val?.price),
        0
      ) +
      parseInt(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount +
        (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
      );
    let depositamount =
      (cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
        parseInt(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )) *
      (depositprect?.value / 100);
    let subtotal =
      cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
      parseInt(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount -
        (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
      );
    let summaryorder = {
      labour: pricelabour,
      shipping: priceshipping,
      loyality_points: priceloyality,
      customer_id: customer,
      sales_person_id: saleperson,
      discount: discount?.amount,
      discount_percent: discount?.prect,
      deposit:
        status_type === "pos_order" ||
          ordertype === "gift_card_order" ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? "0"
          : depositprect?.value,
      deposit_amount:
        status_type === "pos_order" ||
          ordertype === "gift_card_order" ||
          ordertype === "deposit" ||
          reserve_status === 0
          ? "0"
          : depositamount,
      tax_amount: taxes?.amount,
      tax_amount_int: taxes?.taxintamount,
      tax_prect: taxes?.prect,
      tax_type: taxes?.type,
      Sub_Total: subtotal,
    };
    try {
      const postdata = {
        sell_info: {
          cart: carts,
          summary_order: summaryorder,
          status_type: status_type
            ? status_type
            : mainstatustype
              ? mainstatustype
              : ordertype,
          totalamount: totalamount,
        },

        totalamount: parseFloat(totalamount),
        quatetime: quatesentence,
        duedate: TransactionDate,
      };
      setLoader(true);
      let res = await _Api(postdata, `api/v1/POS/quatation/saveQuatation`);
      if (res.code === 200) {
        setShowcheckout("blank");
        setTimeout(() => {
          navigate("/app/pos/Quotation");
        }, 100);
      } else {
        error(res?.message);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoader(false);
    }
  };
  const closePinModal = () => {
    const pinModalEl = document.getElementById('pinModal');
    if (pinModalEl) {
      pinModalEl.style.display = 'none';
      pinModalEl.classList.remove('show');
      document.body.classList.remove('modal-open');
    }
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
  };
  const ordercheckout = async () => {
    let carts = [...cartdetails];
    let totalamount = deletecartids.length
      ? 0
      : ordertype === "exchange_order"
        ? cartdetails?.reduce(
          (interation, val) =>
          (interation =
            interation + parseInt(val.Qty) * val?.perProductPrice),
          0
        ) +
        parseInt(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )
        : cartdetails?.reduce(
          (interation, val) =>
            (interation = interation + parseInt(val.Qty) * val?.price),
          0
        ) +
        parseInt(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        );
    let depositamount =
      (cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
        parseInt(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )) *
      (depositprect?.value / 100);
    let subtotal =
      ordertype === "exchange_order"
        ? cartdetails?.reduce(
          (interation, val) =>
          (interation =
            interation +
            parseInt(val.Qty) * toUnformatPrice(val?.perProductPrice)),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount -
          (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
        )
        : cartdetails?.reduce(
          (interation, val) =>
          (interation =
            interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
          0
        ) +
        parseFloat(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount -
          (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
        );
    let summaryorder = {
      labour: cartdelete?.labour === 0 ? 0 : pricelabour,
      shipping: cartdelete?.shipping === 0 ? 0 : priceshipping,
      loyality_points: cartdelete?.loyality_points === 0 ? 0 : priceloyality,
      customer_id: customer,
      sales_person_id: saleperson,
      discount: cartdelete?.discount === 0 ? 0 : discount?.amount,
      discount_percent:
        cartdelete?.discount_percent === 0 ? 0 : discount?.prect,
      deposit:
        cartdelete?.deposit === 0
          ? 0
          : status_type === "pos_order" ||
            ordertype === "gift_card_order" ||
            ordertype === "deposit" ||
            reserve_status === 0
            ? "0"
            : depositprect?.value,
      deposit_amount:
        cartdelete?.deposit_amount === 0
          ? 0
          : status_type === "pos_order" ||
            ordertype === "gift_card_order" ||
            ordertype === "deposit" ||
            reserve_status === 0
            ? "0"
            : depositamount,
      tax_amount: cartdelete?.tax_amount === 0 ? 0 : taxes?.amount,
      tax_amount_int:
        cartdelete?.tax_amount_int === 0 ? 0 : taxes?.taxintamount,
      tax_prect: cartdelete?.tax_prect === 0 ? 0 : taxes?.prect,
      tax_type: taxes?.type,
      Sub_Total: cartdelete?.Sub_Total === 0 ? 0 : subtotal,
    };
    if (!customer?.id) {
      closePinModal();
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      closePinModal();
      error(t("SalePerson is Requried!!"));
      return;
    }
    setLoader(true);
    const postdata = {
      sell_info: {
        cart: carts,
        summary_order: summaryorder,
        status_type: status_type
          ? status_type
          : mainstatustype
            ? mainstatustype
            : ordertype,
        totalamount: totalamount,
        deletecart_ids: deletecartids,
      },
      payment_info: {
        balance_due:
          UpdatedCart?.sell_info?.totalamount - UpdatedCart?.totalamount
            ? UpdatedCart?.sell_info?.totalamount - UpdatedCart?.totalamount
            : 0,
        balance_deposit: UpdatedCart?.totalamount,
      },
      customer_id: customer?.id,
      sales_person_id: saleperson?.value,
      transaction_date: TransactionDate,
      order_id: linkedOrderIdsRef.current?.length
        ? linkedOrderIdsRef.current
        : order_id,
      order_type: ordertype,
      shippingInfo: {},
    };
    let res = await _Api(postdata, `api/v1/POS/customOrder/saveCustomOrder`);
    if (res.code === 200) {
      setLoader(false);
      localStorage.removeItem("showcheckout");
      clearFaroSessionsAfterCheckout();
      setcheckoutdetails(res?.data);
      setShoworder(true);
    } else {
      setLoader(false);
      error(res?.message);
      closePinModal();
    }
  };
  const editcheckoutorder = async () => {
    let carts = [...cartdetails];
    let totalamount = deletecartids.length
      ? 0
      : cartdetails?.reduce(
        (interation, val) =>
          (interation = interation + parseInt(val.Qty) * val?.price),
        0
      ) +
      parseInt(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount +
        (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
      );
    let depositamount =
      (cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
        parseInt(
          pricelabour +
          priceshipping +
          priceloyality -
          discount?.amount +
          (taxes?.type !== "Inclusive" ? taxes?.taxintamount : "")
        )) *
      (depositprect?.value / 100);
    let subtotal =
      cartdetails?.reduce(
        (interation, val) =>
        (interation =
          interation + parseInt(val.Qty) * toUnformatPrice(val?.price)),
        0
      ) +
      parseInt(
        pricelabour +
        priceshipping +
        priceloyality -
        discount?.amount -
        (taxes?.type === "Inclusive" ? taxes?.taxintamount : "")
      );
    let summaryorder = {
      labour: cartdelete?.labour === 0 ? 0 : pricelabour,
      shipping: cartdelete?.shipping === 0 ? 0 : priceshipping,
      loyality_points: cartdelete?.loyality_points === 0 ? 0 : priceloyality,
      customer_id: customer,
      sales_person_id: saleperson,
      discount: cartdelete?.discount === 0 ? 0 : discount?.amount,
      discount_percent:
        cartdelete?.discount_percent === 0 ? 0 : discount?.prect,
      deposit:
        cartdelete?.deposit === 0
          ? 0
          : status_type === "pos_order" ||
            ordertype === "gift_card_order" ||
            ordertype === "deposit" ||
            reserve_status === 0
            ? "0"
            : depositprect?.value,
      deposit_amount:
        cartdelete?.deposit_amount === 0
          ? 0
          : status_type === "pos_order" ||
            ordertype === "gift_card_order" ||
            ordertype === "deposit" ||
            reserve_status === 0
            ? "0"
            : depositamount,
      tax_amount: cartdelete?.tax_amount === 0 ? 0 : taxes?.amount,
      tax_amount_int:
        cartdelete?.tax_amount_int === 0 ? 0 : taxes?.taxintamount,
      tax_prect: cartdelete?.tax_prect === 0 ? 0 : taxes?.prect,
      tax_type: taxes?.type,
      Sub_Total: cartdelete?.Sub_Total === 0 ? 0 : subtotal,
    };
    setLoader(true);
    const postdata = {
      sell_info: {
        cart: carts,
        summary_order: summaryorder,
        status_type: status_type
          ? status_type
          : mainstatustype
            ? mainstatustype
            : ordertype,
        totalamount: totalamount,
        deletecart_ids: deletecartids,
      },
      payment_info: {
        balance_due:
          UpdatedCart?.sell_info?.totalamount - UpdatedCart?.totalamount,
        balance_deposit: UpdatedCart?.totalamount,
      },
      customer_id: customer?.id,
      sales_person_id: saleperson?.value,
      transaction_date: TransactionDate,
      order_type: UpdatedCart?.ordertype
        ? UpdatedCart?.ordertype
        : UpdatedCart?.sell_info?.status_type
          ? UpdatedCart?.sell_info?.status_type
          : order_type,
      order_id: linkedOrderIdsRef.current?.length
        ? linkedOrderIdsRef.current
        : order_id ? order_id : "",
      order_edit: order_edit,
    };
    try {
      let res = await _Api(postdata, `api/v1/POS/customOrder/EditCustomOrder`);
      if (res.code === 200) {
        localStorage.removeItem("showcheckout");
        clearFaroSessionsAfterCheckout();
        setLoader(false);
        setcheckoutdetails(res?.data);
        setShoworder(true);
      } else {
        error(t("Please Try Again!!"));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const verfypin = async () => {
    try {
      const postdata = {
        verfypin: otpnumber.join().replace(/,/g, ""),
      };
      let res = await _Api(postdata, `api/v1/POS/common/loginPINVerfy`);
      if (res.code === 200) {
        if (order_edit && order_id && order_type) {
          editcheckoutorder();
        } else {
          ordercheckout();
        }
      } else {
        error(t("Please Try Again!!"));
        setOtpnumber([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (
      generalsettings?.data?.generalsetup?.Users_to_enter_PIN_for_every_sale ===
      "1"
    ) {
      if (otpnumber?.length === 6) {
        verfypin();
      }
    }
    // eslint-disable-next-line
  }, [otpnumber]);
  const AddtoCart = async (product_id, orderid, stock_id) => {
    setOrderPreserve((current) =>
      current.includes(stock_id) ? current : [...current, stock_id]
    );
    const GetloadingID = loading();
    try {
      const postdata = {
        product_id: product_id,
        type: "inventory",
        customer_id: customer?.id ? customer?.id : "",
        order_type: "pos_order",
        sales_person_id: saleperson?.value ? saleperson?.value : "",
        park_id: state1?.parkid,
        // order_id: state1?.order_id ? state1?.order_id : orderid,
        sessioncartid: uuid ? uuid : "",
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/addItemToCart`);
      if (res.code === 200) {
        // setsearchproductstatus(true);
        Updateloading(t, GetloadingID, t("Successfully Add to Cart!!"));
        hasFetchedCartRef.current = true;
        refreshCartFromLinkedOrders(linkedOrderIdsRef.current);
        if (state1?.parkid) {
          GetCartdetailpark(state1.parkid);
        }
      } else {
        Updateloading(t, GetloadingID, t("This Product Already in cart!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };
  const GetCartdetailpark = async (parkid) => {
    try {
      const postdata = {
        park_id: parkid,
        // order_id: state1?.order_id,
        // order_edit: state1?.order_edit,
        // order_type: state1?.order_type,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`);
      if (res.code === 200) {
        setUpdatedCart(res?.data);
        const cart = res?.data?.sell_info?.cart || [];
        setCartdetails(cart);
        syncPosscreenFaroConfirmedFromCart(cart);
        if (res?.data?.sell_info?.summary_order?.customer_id) {
          dispatch(
            updateCustomer(res?.data?.sell_info?.summary_order?.customer_id),
          );
          localStorage.setItem(
            "customerdetails",
            JSON.stringify(res?.data?.sell_info?.summary_order?.customer_id),
          );
        }
        if (res?.data?.sell_info?.summary_order?.sales_person_id?.value) {
          dispatch(
            updateSaleperson(
              res?.data?.sell_info?.summary_order?.sales_person_id,
            ),
          );
          localStorage.setItem(
            "salesdetails",
            JSON.stringify(
              res?.data?.sell_info?.summary_order?.sales_person_id,
            ),
          );
        }
        // setsearchproductstatus(true);
        setShowcheckout("sell");
      } else {
        navigate("/app/pos/catalog/CollectionList");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    changediscount("all");
    // eslint-disable-next-line
  }, [cartdetails]);
  // recallPark puts the parked rows back and returns the order_id entries for linked rows;
  // the cart fetch (withOrder) then shows them together with what is already in the cart.
  const recallPark = async (parkid) => {
    const GetloadingID = loading();
    try {
      const res = await _Api(
        { park_id: parkid, customer_id: customer?.id ? customer?.id : "" },
        `api/v1/POS/park/recallPark`
      );
      if (res.code !== 200) {
        Updateloading(t, GetloadingID, res?.message || t("Something went wrong"), "error");
        return;
      }
      const { customer: parkCustomer, sales_person, order_id: parkedOrders } = res?.data || {};
      if (parkCustomer) {
        dispatch(updateCustomer(parkCustomer));
        localStorage.setItem("customerdetails", JSON.stringify(parkCustomer));
      }
      if (sales_person?.value) {
        dispatch(updateSaleperson(sales_person));
        localStorage.setItem("salesdetails", JSON.stringify(sales_person));
      }
      const nextLinked = [...(linkedOrderIdsRef.current || [])];
      (parkedOrders || []).forEach((entry) => {
        if (!nextLinked.some((item) => isSameLinkedOrderEntry(item, entry))) {
          nextLinked.push(entry);
        }
      });
      setLinkedOrderIds(nextLinked);
      setShowcheckout("sell");
      setParkRefreshKey((key) => key + 1);
      await refreshCartFromLinkedOrders(nextLinked, deletecartids, true);
      Updateloading(t, GetloadingID, t("Park recalled successfully"));
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };
  useEffect(() => {
    const recallId = park_id || state1?.parkId;
    if (!recallId) return;
    recallPark(recallId);
    // Done with this id: a refresh or re-render must not recall it again.
    setpark_id(undefined);
    if (state1?.parkId) {
      navigate(location1.pathname, {
        replace: true,
        state: { ...location1.state, state1: { ...state1, parkId: undefined } },
      });
    }
    // eslint-disable-next-line
  }, [park_id, state1?.parkId]);
  // A sale can start again after parking left the blank panel showing.
  useEffect(() => {
    if (cartdetails?.length && showcheckout === "blank") {
      setShowcheckout("sell");
    }
    // eslint-disable-next-line
  }, [cartdetails]);
  useEffect(() => {
    if (!OrgSettings || cartdetails === undefined) {
      return;
    }
    changeTax("default", OrgSettings?.tax?.value);
    // eslint-disable-next-line
  }, [
    OrgSettings,
    cartdetails,
    pricelabour,
    priceshipping,
    priceloyality,
    discount,
  ]);
  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="catalog-area">
              <div
                className="catalog-area-header-area-control-pos"
                style={{ backgroundColor: "#E1F3F2" }}
              >
                <div className="catalog-area-header-area-control-pos-left page-back-btn-inside">
                  <Link to="/app/pos/menu">
                    <img
                      className="page-back-btn-inside-img"
                      src={base_assets + "/images/icons/arrow-left.png"}
                      alt="back"
                    />
                  </Link>
                  <h1 className="heading">{t("POS")}</h1>
                </div>
                {/* <CatalogNavbar setproductNavid={setproductNavid} navid={state?.NavId} location={"/app/pos/products"} pNavid={pNavid} /> */}
                <div className="catalog-area-header-area-control-pos-right">
                  <div className="com-search-area">
                    <button className="com-search-area-left-img">
                      <img
                        src={base_assets + "images/pos/icons/scan-icon.png"}
                        alt=""
                      />
                    </button>
                    <input
                      type="text"
                      // onChange={(e) => {
                      //   setSearchsku(e.target.value);
                      //   getsearchcatalog(e.target.value);
                      // }}
                      onChange={(e) => {
                        const value = e.target.value;
                    
                        setSearchsku(value);
                    
                        if (searchDebounceRef.current) {
                            clearTimeout(searchDebounceRef.current);
                        }
                    
                        searchDebounceRef.current = setTimeout(() => {
                            getsearchcatalog(value);
                        }, 300);
                    }}
                      placeholder={t("Scan barcode, Search SKU or Product")}
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      autoComplete="off"
                    />
                    <ul
                      className={`dropdown-menu custom-search-dropdown1 ${showDropdown && searchlist?.length ? "show" : ""
                        }`}
                      aria-labelledby="dropdownMenuButton1"
                    
                    >
                      {searchlist?.length
                        ? searchlist.map((result, key) => {
                          return (
                            <li
                              key={key}
                              className="dropdown-item pos-search-result-item"
                              onClick={() => handleSearchItemClick(result)}
                            >
                              <div className="pos-search-result-thumb">
                                {result?.main_image ? (
                                  <img
                                    src={result.main_image}
                                    alt=""
                                    onError={(e) => {
                                      e.target.onerror = null; // prevent infinite loop
                                      e.target.src = "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                    }}
                                  />
                                ) : null}
                              </div>
                              <div className="pos-search-result-text">
                                <div className="pos-search-result-name">
                                  {result?.name}
                                </div>
                                <div className="pos-search-result-meta">
                                  {result?.SKU}
                                  {result?.stock_id
                                    ? " - " + result.stock_id
                                    : ""}
                                  {result?.status_type
                                    ? ` · ${result.status_type.replace("_", " ")}`
                                    : ""}
                                </div>
                              </div>
                            </li>
                          );
                        })
                        : ""}
                    </ul>
                    <img
                      className="com-search-area-img"
                      src={
                        base_assets + "images/pos/icons/magnifying-glass.png"
                      }
                      alt=""
                    />
                  </div>
                </div>
                <div className="catalog-area-header-area-control-pos-right">
                  <div
                    className={
                      parmissiondatashow?.pos_custom_order?.View
                        ? "custom-tooltip"
                        : "d-none"
                    }
                  >
                    <Link to="/app/pos/posscreen/posorderlist">
                      <img
                        className="custom-order-img"
                        src={
                          base_assets + "images/pos/icons/custom-order-icon.png"
                        }
                        alt=""
                      />
                      <span className="com-btn custom-tooltip-text">
                        {t("Custom Order")}
                      </span>
                    </Link>
                    {orderCount ? (
                      <span className="notification-area-count">
                        <span className="notification-area-count-num">
                          {orderCount}
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  padding: "26px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {/* kishna */}
                {cartdetails?.length ? (
                  <>
                    {cartdetails?.length &&
                      cartdetails?.map((result, index) => {
                        return (
                          <div className="cart-wrapper">
                            <>
                              <div className="cart-item" key={index}>
                                <div className="cart-item-left">
                                  {!result?.status?.is_mix_match && (
                                    <div className="cart-index">
                                      {index + 1}
                                    </div>
                                  )}

                                  <div className="cart-image-container">
                                    {result?.main_image ? (
                                      <img
                                        src={result.main_image}
                                        alt="cart-item"
                                        className="cart-image"
                                      />
                                    ) : (
                                      <div className="cart-image-placeholder"></div>
                                    )}
                                  </div>

                                  <div className="cart-details">
                                    <div className="cart-title">
                                      {result?.name
                                        ? result?.name?.length > 65
                                          ? result?.name?.slice(0, 64) + "..."
                                          : result?.name
                                        : ""}
                                    </div>
                                    <span className="cart-price-1">
                                      {toFormatPrice(result?.retailprice_Inc, {
                                        addSymbol: true,
                                      })}
                                    </span>
                                    <div className="cart-sub-details">
                                      <div className="cart-sku">
                                        {result?.SKU}
                                      </div>
                                      <div className="cart-size">
                                        {result?.metal_name
                                          ? result?.metal_name
                                          : ""}
                                      </div>
                                      <div className="cart-size">
                                        {result?.stone_name
                                          ? result?.stone_name
                                          : ""}
                                      </div>
                                      <div className="cart-size">
                                        {result?.size_name
                                          ? "#" + result?.size_name
                                          : ""}
                                      </div>
                                    </div>
                                    <span className="cart-price-1">
                                      {result?.stock_id}
                                    </span>
                                  </div>
                                </div>

                                <div className="cart-item-right">
                                  <div className="cart-inputs">
                                    <div
                                      className={`floating-label-input ${result?.discount_percent ? "active" : ""
                                        }`}
                                    >
                                      <input
                                        type="number"
                                        value={
                                          result?.discount_percent
                                            ? result?.discount_percent
                                            : ""
                                        }
                                        onChange={(e) =>
                                          changecartdiscount(
                                            e.target.value,
                                            index,
                                            "discountprecent"
                                          )
                                        }
                                        required
                                      />
                                      <label>Dis(%)</label>
                                    </div>

                                    <div
                                      className={`floating-label-input ${result?.Discount_Amount ? "active" : ""
                                        }`}
                                    >
                                      <input
                                        type="number"
                                        value={
                                          result?.Discount_Amount
                                            ? result?.Discount_Amount
                                            : ""
                                        }
                                        onChange={(e) =>
                                          changecartdiscount(
                                            e.target.value,
                                            index,
                                            "discountamount"
                                          )
                                        }
                                        required
                                      />
                                      <label>Dis(Amt)</label>
                                    </div>
                                  </div>

                                  <div className="cart-qty">
                                    <div className="qty-buttons">
                                      <button
                                        className="btn-style"
                                        disabled={isLinkedCartLine(result)}
                                        style={isLinkedCartLine(result) ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                                        title={isLinkedCartLine(result) ? t("Quantity comes from the linked order") : undefined}
                                        onClick={() =>
                                          changeQty(
                                            index,
                                            "remove",
                                            ordertype === "exchange_order" ||
                                              ordertype === "repair_order" ||
                                              ordertype === "refund_order"
                                              ? result?.qtyToBe
                                              : result?.po_QTY
                                          )
                                        }
                                      >
                                        <img
                                          src={
                                            base_assets +
                                            "images/icons/minus-icon.png"
                                          }
                                          alt=""
                                        />
                                      </button>
                                      <span className="qty-count">
                                        {result?.Qty ? result?.Qty : 1}
                                      </span>
                                      <button
                                        className="btn-style"
                                        disabled={isLinkedCartLine(result)}
                                        style={isLinkedCartLine(result) ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                                        title={isLinkedCartLine(result) ? t("Quantity comes from the linked order") : undefined}
                                        onClick={() =>
                                          changeQty(
                                            index,
                                            "add",
                                            ordertype === "exchange_order" ||
                                              ordertype === "repair_order" ||
                                              ordertype === "refund_order"
                                              ? result?.qtyToBe
                                              : result?.po_QTY
                                          )
                                        }
                                      >
                                        <img
                                          src={
                                            base_assets +
                                            "images/icons/add-icon.png"
                                          }
                                          alt=""
                                        />
                                      </button>
                                    </div>
                                  </div>

                                  <div className="cart-price-actions">
                                    <span
                                      className="cart-price"
                                      style={{
                                        color:
                                          result?.discount_percent > 0 ||
                                            result?.Discount_Amount > 0
                                            ? "red"
                                            : "",
                                      }}
                                    >
                                      {toFormatPrice(result?.price, {
                                        addSymbol: true,
                                      })}
                                    </span>
                                    <span className="cart-tax">
                                      Tax{" "}
                                      {toFormatPrice(
                                        calculateTax(
                                          result?.price,
                                          taxes?.prect,
                                          OrgSettings?.tax?.type
                                        ),
                                        {
                                          addSymbol: true,
                                        }
                                      )}{" "}
                                      ({taxes?.prect}%{" "}
                                      {OrgSettings?.tax?.type === "Exclusive"
                                        ? " Exc"
                                        : " Inc"}
                                      )
                                    </span>

                                    <div className="cart-icons">
                                      {ordertype === "pos_order" &&
                                        (result?.Service_labour_exsist ||
                                          result?.service_labour_exsist ? (
                                          <div className="service-icon active">
                                            <img
                                              src={
                                                base_assets +
                                                "images/pos/icons/labour_green.png"
                                              }
                                              alt=""
                                            />
                                          </div>
                                        ) : (
                                          <div
                                            className={`${generalsettings?.data
                                              ?.generalsetup
                                              ?.servicelabers === "1"
                                              ? "service-icon labour-hover"
                                              : "d-none"
                                              } ${result?.linked_order_id?"":""}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#servicelabour"
                                            onClick={() => {
                                              setCart_id(
                                                result?.custom_cart_id
                                              );
                                              setProduct_price(result?.price);
                                              setScrvicelist([]);
                                              setServicelabourlist([]);
                                              setScrviceremark(
                                                result?.Service_labour?.service_remark ||
                                                result?.service_labour?.service_remark ||
                                                ""
                                              );
                                            }}
                                          >
                                            <img
                                              src={
                                                base_assets +
                                                "images/pos/icons/labour_gray.png"
                                              }
                                              alt="labour"
                                              className="labour-icon"
                                            />
                                          </div>
                                        ))}

                                      {!result?.status?.is_mix_match && (
                                        <div className="service-icon-1">
                                          <button
                                            className="btn-style delete-btn"
                                            onClick={() =>
                                              deletecart(
                                                result?.custom_cart_id,
                                                result?.transaction_type,
                                                result?.amount,
                                                result?.sessioncartid,
                                                result?.stock_id
                                              )
                                            }
                                          >
                                            <img
                                              // src={
                                              //   base_assets +
                                              //   "images/pos/icons/delete-icon.png"
                                              // }
                                              src={deleteiconimg}
                                              alt=""
                                            />
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {(result?.Service_labour_exsist ||
                                result?.service_labour_exsist) &&
                                result?.Service_labour?.service_laburelist
                                  ?.length > 0 && (
                                  <>
                                    <div
                                      style={{
                                        border: "1px solid #F2F2F2",
                                        margin: "1vw 0",
                                      }}
                                    ></div>

                                    {result?.Service_labour?.service_laburelist.map(
                                      (labour, labourindex) => (
                                        <div
                                          className="cart-item-1"
                                          key={labourindex}
                                        >
                                          {/* Left Side */}
                                          <div className="cart-item-left-1">
                                            <span className="service-labour-text">
                                              +({labour?.code}) {labour?.name}
                                            </span>
                                            <img
                                              data-bs-toggle="modal"
                                              data-bs-target="#servicelabour"
                                              style={{ width: "0.8vw" }}
                                              src={
                                                base_assets +
                                                "images/pos/icons/red-delete.png"
                                              }
                                              alt=""
                                              onClick={() => {
                                                setCart_id(
                                                  result?.custom_cart_id
                                                );
                                                setProduct_price(
                                                  result?.Service_labour
                                                    ?.product_price
                                                );
                                                setScrvicelist(
                                                  result?.Service_labour
                                                    ?.service_laburelist
                                                );
                                                setScrviceedit(true);
                                                setServicelabourlist(
                                                  result?.Service_labour
                                                    ?.service_laburelist
                                                );
                                                setScrviceremark(
                                                  result?.Service_labour?.service_remark ||
                                                  result?.service_labour?.service_remark ||
                                                  ""
                                                );
                                                setShowmodal(true);
                                              }}
                                              className={`${result?.linked_order_id?"":""}`}
                                            />
                                          </div>

                                          {/* Right Side */}
                                          <div className="cart-item-right-1">
                                            <div className="cart-price-actions">
                                              <span className="cart-price">
                                                {toFormatPrice(
                                                  labour?.scrviceamount,
                                                  { addSymbol: true }
                                                )}
                                              </span>
                                              <span className="cart-tax">
                                                Tax{" "}
                                                {toFormatPrice(
                                                  calculateTax(
                                                    labour?.scrviceamount,
                                                    taxes?.prect,
                                                    OrgSettings?.tax?.type
                                                  ),
                                                  { addSymbol: true }
                                                )}{" "}
                                                ({taxes?.prect}%{" "}
                                                {OrgSettings?.tax?.type ===
                                                  "Exclusive"
                                                  ? " Exc"
                                                  : " Inc"}
                                                )
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </>
                                )}
                            </>
                          </div>
                        );
                      })}
                  </>
                ) : (
                  <img
                    src={posplaceholderimage}
                    alt="placeholderimg"
                    style={{ width: "100%" }}
                  />
                )}
                {
                  <Servicelabourmodal
                    setService_enable={setService_enable}
                    setScrviceremark={setScrviceremark}
                    setScrvicelist={setScrvicelist}
                    setScrvicecharge={setScrvicecharge}
                    scrvicelist={scrvicelist}
                    scrviceremark={scrviceremark}
                    cart_id={cart_id}
                    GetCartdetail={GetCartdetail}
                    onCartRefresh={() =>
                      refreshCartFromLinkedOrders(linkedOrderIdsRef.current)
                    }
                    order_edit={order_edit}
                    order_type={order_type}
                    order_id={linkedOrderIds}
                    product_price={product_price}
                    service_enable={service_enable}
                    setService_saved={setService_saved}
                    service_saved={service_saved}
                    servicelabourlist={servicelabourlist}
                    setServicelabourlist={setServicelabourlist}
                    setShowmodal={setShowmodal}
                    setPricelabour={setPricelabour}
                    edit={edit}
                    showmodal={showmodal}
                  />
                }
              </div>
              <Link
                to="/app/pos/catalog/smart-search"
                state={{ fromPosscreen: true }}
                className="catalog-area__faro-search"
                aria-label={t("FARO Search")}
                aria-disabled={!isFaroActive}
                onClick={handleFaroClick}
                style={!isFaroActive ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
                // title={t("FARO Search")}
              >
              <div
          className="kycTooltip-area-up"
          style={{ width: "auto", height: "auto",marginTop:0 }}
        >
                <img src={faromainicon} alt="" aria-hidden />
                <span className="kycTooltip-area-up-text" style={{  minWidth:'32px',padding:'5px 5px',  bottom: 'calc(100% - -4px)'}}>faro</span>

              </div>
              </Link>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === "sell" ? (
              <>
                <div className="main-body-row-right-col-inner">
                  <div
                    className="main-body-row-right-col-inner-ct-top"
                    style={{ height: "12%" }}
                  >
                    <div className="main-body-row-right-col-inner-ct-top-inner h-100 d-flex flex-column justify-content-evenly">
                      <div className="main-body-row-right-col-inner-ct-top-inner-date-area">
                        <div className="main-body-row-right-col-inner-ct-top-inner-date-area-inner">
                          <span>
                            {status_type === "custom_order" ||
                              status_type === "mix_and_match"
                              ? "CO-XXX"
                              : status_type === "pos_order"
                                ? "POS-XXX"
                                : "XXXX"}
                          </span>{" "}
                          :
                          <div className="main-body-row-right-col-inner-ct-top-inner-date-area-inner-input date">
                            <DatePicker
                              className="date-field"
                              selected={TransactionDate}
                              onChange={(input) => setTransactionDate(input)}
                              name="TransactionDate"
                              dateFormat={OrgSettings?.date_picker}
                              autoComplete="off"
                              popperPlacement="top-start"
                            />
                            <img
                              className="date-img"
                              src={
                                base_assets + "images/icons/calendar-green.svg"
                              }
                              alt=""
                            />
                          </div>
                        </div>
                        <div
                          className={
                            saleperson?.value
                              ? "main-body-row-right-col-inner-ct-top-inner-date-area-select ms-2"
                              : "main-body-row-right-col-inner-ct-top-inner-date-area-select grey-select ms-2"
                          }
                        >
                          <Saleperson />
                        </div>
                      </div>
                      <div className="main-body-row-right-col-inner-ct-top-inner-search">
                        <CustomerSearchModal
                          setCusid={setCusid}
                        ></CustomerSearchModal>
                        {parmissiondatashow?.pos_customer_reports?.Add ? (
                          <span className="main-body-row-right-col-inner-ct-top-inner-search-user">
                            <img
                              data-bs-toggle="modal"
                              data-bs-target="#customerAddModal"
                              src={
                                base_assets + "images/pos/icons/add-user.png"
                              }
                              alt=""
                            />
                          </span>
                        ) : (
                          ""
                        )}
                        {customer?.id ? (
                          <span
                            className={
                              parts[3] !== "exchange" &&
                                parts[3] !== "refund" &&
                                parts[3] !== "reserve" &&
                                parts[3] !== "receive"
                                ? "main-body-row-right-col-inner-ct-top-inner-search-user"
                                : "d-none"
                            }
                            onClick={() => {
                              setToggleAddressCustomer(!toggleAddressCustomer);
                            }}
                          >
                            {customer?.existsInAddress || order_edit ? (
                              <img src={addressicon} alt="" />
                            ) : (
                              <img
                                className="iconwithnotification"
                                src={notaddressicon}
                                alt=""
                              />
                            )}
                          </span>
                        ) : (
                          <span
                            className={
                              parts[3] !== "exchange" &&
                                parts[3] !== "refund" &&
                                parts[3] !== "reserve" &&
                                parts[3] !== "receive"
                                ? "main-body-row-right-col-inner-ct-top-inner-search-user"
                                : "d-none"
                            }
                            onClick={() => {
                              error(t("Customer is Requried!!"));
                            }}
                          >
                            <img src={addressicon} alt="" />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      height: "88%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {toggleAddressCustomer && customer?.id ? (
                      <AddCustomerAddressPopup />
                    ) : (
                      <>
                        {ordertype === "exchange_order" ? (
                          <div
                            className="main-body-row-right-col-inner-progress mt-1"
                            style={{ height: "12%" }}
                          >
                            <div className="main-body-row-right-col-inner-progress-line">
                              <div className="main-body-row-right-col-inner-progress-line-single col active"></div>
                              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
                            </div>

                            <div className="main-body-row-right-col-inner-progress-step space-evenly">
                              <div className="main-body-row-right-col-inner-progress-step-single active">
                                <div className="main-body-row-right-col-inner-progress-step-single-circle">
                                  <span className="main-body-row-right-col-inner-progress-step-single-circle-dot"></span>
                                </div>
                                <span className="main-body-row-right-col-inner-progress-step-single-text">
                                  {t("Exchange")}
                                </span>
                              </div>
                              <div className="main-body-row-right-col-inner-progress-step-single">
                                <div className="main-body-row-right-col-inner-progress-step-single-circle"></div>
                                <span className="main-body-row-right-col-inner-progress-step-single-text">
                                  {t("done")}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="main-body-row-right-col-inner-progress mt-1"
                            style={{ height: "12%" }}
                          >
                            <div className="main-body-row-right-col-inner-progress-line">
                              <div className="main-body-row-right-col-inner-progress-line-single col active"></div>
                              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
                              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
                              <div className="main-body-row-right-col-inner-progress-line-single col"></div>
                            </div>
                            <div className="main-body-row-right-col-inner-progress-step">
                              <div className="main-body-row-right-col-inner-progress-step-single active">
                                <div className="main-body-row-right-col-inner-progress-step-single-circle">
                                  <span className="main-body-row-right-col-inner-progress-step-single-circle-dot"></span>
                                </div>
                                <span className="main-body-row-right-col-inner-progress-step-single-text">
                                  {ordertype === "refund_order"
                                    ? t("Refund")
                                    : t("sell")}
                                </span>
                              </div>
                              <div
                                className={
                                  showpayment
                                    ? "main-body-row-right-col-inner-progress-step-single second active"
                                    : "main-body-row-right-col-inner-progress-step-single second"
                                }
                                onClick={() => {
                                  if (showpayment) {
                                    callpaymentcheckout();
                                  }
                                }}
                              >
                                <div className="main-body-row-right-col-inner-progress-step-single-circle"></div>
                                <span className="main-body-row-right-col-inner-progress-step-single-text">
                                  {t("Payment")}
                                </span>
                              </div>
                              <div className="main-body-row-right-col-inner-progress-step-single">
                                <div className="main-body-row-right-col-inner-progress-step-single-circle"></div>
                                <span className="main-body-row-right-col-inner-progress-step-single-text">
                                  {t("done")}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                        <div
                          className={
                            ordertype === "deposit"
                              ? "main-body-row-right-col-inner-list box-1 position-sticky event-none d-flex flex-column justify-content-between"
                              : "main-body-row-right-col-inner-list box-1 position-sticky d-flex flex-column justify-content-between"
                          }
                          style={{
                            marginTop: "auto",
                            height: "unset",
                            maxHeight: "unset",
                          }}
                        >
                          <div className="main-body-row-right-col-inner-summary-wrap position-sticky">
                            <div
                              className={
                                ordertype === "exchange_order" ||
                                  ordertype === "refund_order" ||
                                  ordertype === "deposit" ||
                                  reserve_status === 0
                                  ? "main-body-row-right-col-inner-summary box-2 event-none"
                                  : "main-body-row-right-col-inner-summary box-2"
                              }
                              style={{
                                height: "fit-content",
                                maxHeight: "fit-content",
                              }}
                            >
                              <div className={isSummaryActive ? "" : "d-none"}>
                                <h2 className="main-body-row-right-col-inner-summary-heading">
                                  {t("Summary Order")}
                                  <span>
                                    {cartdetails?.length
                                      ? cartdetails?.reduce(
                                        (interation, val) =>
                                        (interation =
                                          interation + parseInt(val.Qty)),
                                        0
                                      )
                                      : ""}
                                    <span> </span>
                                    <label>
                                      {""}
                                      {t("Items")}
                                    </label>
                                  </span>
                                </h2>
                                <div className="main-body-row-right-col-inner-summary-price-data total-boxes">
                                  <div className="main-body-row-right-col-inner-summary-price-data-total">
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text">
                                      {t("Total")}
                                    </span>
                                    {ordertype === "exchange_order" ? (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.perProductPrice
                                                )),
                                              0
                                            ),

                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    ) : ordertype === "repair_order" ? (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ),

                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    ) : (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ),

                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    )}
                                  </div>

                                  <div
                                    className={
                                      by_custom_order || by_repair_order
                                        ? "main-body-row-right-col-inner-summary-price-data-box event-none"
                                        : "main-body-row-right-col-inner-summary-price-data-box"
                                    }
                                  >
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Labour")}
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          disabled={
                                            service_enable ||
                                              scrvicelistmixmatch
                                              ? true
                                              : false
                                          }
                                          className="arrow-none"
                                          value={pricelabour ? pricelabour : 0}
                                          onChange={(e) =>
                                            setPricelabour(
                                              e.target.value
                                                ? parseFloat(e.target.value)
                                                : 0
                                            )
                                          }
                                        />
                                      </span>
                                    </div>
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Shipping")}
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          className="arrow-none"
                                          value={
                                            priceshipping ? priceshipping : 0
                                          }
                                          onChange={(e) =>
                                            setPriceshipping(
                                              e.target.value
                                                ? parseFloat(e.target.value)
                                                : 0
                                            )
                                          }
                                        />
                                      </span>
                                    </div>
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Loyalty points")}
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          className="arrow-none"
                                          value={
                                            priceloyality ? priceloyality : 0
                                          }
                                          onChange={(e) =>
                                            setPriceloyality(
                                              e.target.value
                                                ? parseFloat(e.target.value)
                                                : ""
                                            )
                                          }
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      by_custom_order || by_repair_order
                                        ? "main-body-row-right-col-inner-summary-price-data-box  event-none"
                                        : "main-body-row-right-col-inner-summary-price-data-box"
                                    }
                                  >
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Discount")} (%)
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          className="arrow-none"
                                          value={
                                            discount?.prect
                                              ? discount?.prect
                                              : 0
                                          }
                                          min={0}
                                          max={100}
                                          step={1}
                                          onChange={(e) => {
                                            const value = Math.max(
                                              0,
                                              Math.min(
                                                100,
                                                Number(e.target.value)
                                              )
                                            );
                                            changediscount(
                                              "discountprecent",
                                              value
                                            );
                                          }}
                                        />
                                        %
                                      </span>
                                    </div>
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Discount (Amount)")}
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          className="arrow-none"
                                          onChange={(e) =>
                                            changediscount(
                                              "discountamount",
                                              e.target.value
                                            )
                                          }
                                          value={
                                            discount?.amount
                                              ? parseFloat(discount?.amount)
                                              : 0
                                          }
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="main-body-row-right-col-inner-summary-price-data-total">
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text">
                                      {t("Sub Total1")}
                                    </span>
                                    {ordertype === "exchange_order" ? (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.perProductPrice
                                                )),
                                              0
                                            ) +
                                            parseFloat(
                                              pricelabour +
                                              priceshipping +
                                              priceloyality -
                                              discount?.amount -
                                              (taxes?.type === "Inclusive"
                                                ? taxes?.taxintamount
                                                : "")
                                            ),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    ) : ordertype === "repair_order" ? (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ) +
                                            parseFloat(
                                              pricelabour +
                                              priceshipping +
                                              priceloyality -
                                              discount?.amount -
                                              (taxes?.type === "Inclusive"
                                                ? taxes?.taxintamount
                                                : "")
                                            ),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    ) : (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ) +
                                            parseFloat(
                                              pricelabour +
                                              priceshipping +
                                              priceloyality -
                                              discount?.amount -
                                              (taxes?.type === "Inclusive"
                                                ? taxes?.taxintamount
                                                : "")
                                            ),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    )}
                                  </div>
                                  <div className="main-body-row-right-col-inner-summary-price-data-box">
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        Tax (%)
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        <input
                                          type="number"
                                          className="arrow-none"
                                          value={taxes?.prect}
                                          onChange={(e) =>
                                            changeTax(
                                              "taxprecent",
                                              e.target.value
                                            )
                                          }
                                        />
                                        %
                                      </span>
                                    </div>
                                    <div className="main-body-row-right-col-inner-summary-price-data-box-single">
                                      <label className="main-body-row-right-col-inner-summary-price-data-box-single-label">
                                        {t("Tax (Amount)")}
                                      </label>
                                      <span className="main-body-row-right-col-inner-summary-price-data-box-single-price">
                                        {parseFloat(taxes?.amount)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="main-body-row-right-col-inner-summary-price-data mt-2">
                                <div className="main-body-row-right-col-inner-summary-price-data-total">
                                  <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark">
                                    {t("Grand Total")}
                                  </span>
                                  {ordertype === "exchange_order" ? (
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark ms-auto">
                                      {UpdatedCart?.sell_info?.summary_order
                                        ?.checkOutAmount
                                        ? toFormatPrice(
                                          UpdatedCart?.sell_info
                                            ?.summary_order?.checkOutAmount,
                                          { addSymbol: true }
                                        )
                                        : cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.perProductPrice
                                                )),
                                              0
                                            ) +
                                            parseFloat(
                                              pricelabour +
                                              priceshipping +
                                              priceloyality -
                                              discount?.amount +
                                              (taxes?.type !== "Inclusive"
                                                ? taxes?.taxintamount
                                                : "")
                                            ),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                    </span>
                                  ) : ordertype === "repair_order" ? (
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark ms-auto">
                                      {UpdatedCart?.sell_info?.summary_order
                                        ?.checkOutAmount
                                        ? toFormatPrice(
                                          UpdatedCart?.sell_info
                                            ?.summary_order?.checkOutAmount,
                                          { addSymbol: true }
                                        )
                                        : cartdetails?.length
                                          ? toFormatPrice(
                                            cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                toUnformatPrice(val?.price)),
                                              0
                                            ) +
                                            parseFloat(
                                              pricelabour +
                                              priceshipping +
                                              priceloyality -
                                              discount?.amount +
                                              (taxes?.type !== "Inclusive"
                                                ? taxes?.taxintamount
                                                : "")
                                            ),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                    </span>
                                  ) : (
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark ms-auto">
                                      {cartdetails?.length
                                        ? toFormatPrice(
                                          cartdetails?.reduce(
                                            (interation, val) =>
                                            (interation =
                                              interation +
                                              parseInt(val.Qty) *
                                              parseFloat(val?.price)),
                                            0
                                          ) +
                                          parseFloat(
                                            pricelabour +
                                            priceshipping +
                                            priceloyality -
                                            discount?.amount +
                                            (taxes?.type !== "Inclusive"
                                              ? taxes?.taxintamount
                                              : "")
                                          ),
                                          { addSymbol: true }
                                        )
                                        : 0.0}
                                    </span>
                                  )}
                                  <img
                                    onClick={summaryToggle}
                                    className={
                                      isSummaryActive
                                        ? "ms-2 cursor-pointer p-1"
                                        : "ms-2 cursor-pointer p-1 rotate-90"
                                    }
                                    style={{ minWidth: "24px" }}
                                    src={
                                      base_assets +
                                      "images/pos/icons/arrow-up.png"
                                    }
                                    alt=""
                                  />
                                </div>
                                {ordertype === "pos_order" ||
                                  ordertype === "gift_card_order" ||
                                  ordertype === "deposit" ||
                                  ordertype === "exchange_order" ||
                                  ordertype === "refund_order" ||
                                  reserve_status === 0 ? (
                                  ""
                                ) : (
                                  <div className="main-body-row-right-col-inner-summary-price-data-total">
                                    <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark">
                                      {t("Deposit")}
                                      <Select
                                        value={depositprect}
                                        onChange={(e) => setDepositprect(e)}
                                        options={depositoptionarray}
                                        classNamePrefix="common-select"
                                        isSearchable={false}
                                        className="select-position-up"
                                        menuPlacement="auto"
                                      />
                                    </span>
                                    {ordertype === "repair_order" ? (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            (cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ) +
                                              parseInt(
                                                pricelabour +
                                                priceshipping +
                                                priceloyality -
                                                discount?.amount +
                                                (taxes?.type !== "Inclusive"
                                                  ? taxes?.taxintamount
                                                  : "")
                                              )) *
                                            (depositprect?.value / 100),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    ) : (
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text text-dark ms-auto">
                                        {cartdetails?.length
                                          ? toFormatPrice(
                                            (cartdetails?.reduce(
                                              (interation, val) =>
                                              (interation =
                                                interation +
                                                parseInt(val.Qty) *
                                                toUnformatPrice(
                                                  val?.price
                                                )),
                                              0
                                            ) +
                                              parseInt(
                                                pricelabour +
                                                priceshipping +
                                                priceloyality -
                                                discount?.amount +
                                                (taxes?.type !== "Inclusive"
                                                  ? taxes?.taxintamount
                                                  : "")
                                              )) *
                                            (depositprect?.value / 100),
                                            { addSymbol: true }
                                          )
                                          : 0.0}
                                      </span>
                                    )}
                                  </div>
                                )}

                                {status_type !== "pos_order" ? (
                                  ordertype === "deposit" ||
                                    ordertype === "exchange_order" ||
                                    ordertype === "refund_order" ||
                                    ordertype === "pos_order" ||
                                    ordertype === "gift_card_order" ||
                                    reserve_status === 0 ? (
                                    ""
                                  ) : (
                                    <div className="main-body-row-right-col-inner-summary-price-data-total">
                                      <span className="main-body-row-right-col-inner-summary-price-data-total-text danger-text">
                                        {t("Outstanding Balance")}
                                      </span>
                                      {ordertype === "repair_order" ? (
                                        <span className="main-body-row-right-col-inner-summary-price-data-total-text danger-text ms-auto">
                                          {cartdetails?.length
                                            ? toFormatPrice(
                                              cartdetails?.reduce(
                                                (interation, val) =>
                                                (interation =
                                                  interation +
                                                  toUnformatPrice(
                                                    val?.price
                                                  )),
                                                0
                                              ) +
                                              parseInt(
                                                pricelabour +
                                                priceshipping +
                                                priceloyality -
                                                discount?.amount +
                                                (taxes?.type !==
                                                  "Inclusive"
                                                  ? taxes?.taxintamount
                                                  : "")
                                              ) -
                                              (cartdetails?.reduce(
                                                (interation, val) =>
                                                (interation =
                                                  interation +
                                                  toUnformatPrice(
                                                    val?.price
                                                  )),
                                                0
                                              ) +
                                                parseInt(
                                                  pricelabour +
                                                  priceshipping +
                                                  priceloyality -
                                                  discount?.amount +
                                                  (taxes?.type !==
                                                    "Inclusive"
                                                    ? taxes?.taxintamount
                                                    : "")
                                                )) *
                                              (depositprect?.value / 100),
                                              { addSymbol: true }
                                            )
                                            : 0.0}
                                        </span>
                                      ) : (
                                        <span className="main-body-row-right-col-inner-summary-price-data-total-text danger-text ms-auto">
                                          {cartdetails?.length
                                            ? toFormatPrice(
                                              cartdetails?.reduce(
                                                (interation, val) =>
                                                (interation =
                                                  interation +
                                                  parseInt(val.Qty) *
                                                  toUnformatPrice(
                                                    val?.price
                                                  )),
                                                0
                                              ) +
                                              parseInt(
                                                pricelabour +
                                                priceshipping +
                                                priceloyality -
                                                discount?.amount +
                                                (taxes?.type !==
                                                  "Inclusive"
                                                  ? taxes?.taxintamount
                                                  : "")
                                              ) -
                                              (cartdetails?.reduce(
                                                (interation, val) =>
                                                (interation =
                                                  interation +
                                                  parseInt(val.Qty) *
                                                  toUnformatPrice(
                                                    val?.price
                                                  )),
                                                0
                                              ) +
                                                parseInt(
                                                  pricelabour +
                                                  priceshipping +
                                                  priceloyality -
                                                  discount?.amount +
                                                  (taxes?.type !==
                                                    "Inclusive"
                                                    ? taxes?.taxintamount
                                                    : "")
                                                )) *
                                              (depositprect?.value / 100),
                                              { addSymbol: true }
                                            )
                                            : 0.0}
                                        </span>
                                      )}
                                    </div>
                                  )
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="main-body-row-right-col-inner-footer">
                              <ParkHistoryButton
                                park_id={park_id}
                                setpark_id={setpark_id}
                                refreshKey={parkRefreshKey}
                              />
                              <div className="main-body-row-right-col-inner-footer-row">
                                {ordertype === "pos_order" ? (
                                  <button
                                    className={
                                      generalsettings?.data?.generalsetup
                                        ?.isPark === "1" && cartdetails?.length
                                        ? "btn main-body-row-right-col-inner-footer-row-btn status-pending"
                                        : "d-none"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#parkModal"
                                  >
                                    {t("park")}
                                  </button>
                                ) : ordertype === "custom_order" ||
                                  ordertype === "mix_and_match" ||
                                  ordertype === "repair_order" ? (
                                  parmissiondatashow?.Quotation?.Add &&
                                    generalsettings?.data?.generalsetup
                                      ?.isQuotation === "1" &&
                                    cartdetails?.length ? (
                                    <button
                                      data-bs-toggle="modal"
                                      data-bs-target="#quoteModal"
                                      className="btn main-body-row-right-col-inner-footer-row-btn light-blue"
                                    >
                                      {t("Quote")}
                                    </button>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                                {ordertype === "exchange_order" ? (
                                  <button
                                    data-bs-toggle="modal"
                                    data-bs-target={
                                      ordertype === "exchange_order"
                                        ? "#checkoutorderModal"
                                        : "#checkoutorderrefoundModal"
                                    }
                                    className={
                                      cartdetails?.length
                                        ? "btn checkout main-body-row-right-col-inner-footer-row-btn linear-bg w-100"
                                        : "btn checkout main-body-row-right-col-inner-footer-row-btn linear-bg w-100  btn-disabled pointer-none"
                                    }
                                  >
                                    {t("checkout")}
                                  </button>
                                ) : (
                                  <button
                                    className={
                                      cartdetails?.length
                                        ? "btn checkout main-body-row-right-col-inner-footer-row-btn linear-bg w-100"
                                        : "btn checkout main-body-row-right-col-inner-footer-row-btn linear-bg w-100  btn-disabled pointer-none"
                                    }
                                    onClick={() => callpaymentcheckout()}
                                  >
                                    {t("checkout")}
                                  </button>
                                )}
                              </div>
                              <p className="footer">
                                {t("© 2026. All rights reserved.")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className="modal fade park-quote-modal common-modal"
                  id="parkModal"
                  tabIndex="-1"
                  aria-labelledby="parkModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <h1 className="modal-title">{t("Park this sale?")}</h1>
                        <p className="park-quote-modal-para">
                          {t("Note for the sale you want to park")}
                        </p>
                        <div className="placeholder-up-input">
                          <input
                            className="placeholder-up-input-field"
                            placeholder="Ex. Customer will come back in 10 minutes."
                            value={parksentence}
                            onChange={(e) => setParksentence(e.target.value)}
                            onFocus={() => setShowParkSuggestion(true)}
                            onBlur={() => setShowParkSuggestion(false)}
                          />
                          {showParkSuggestion ? (
                            <div className="park-quote-modal-suggestion">
                              <span className="park-quote-modal-suggestion-title">
                                {t("Suggestion")}
                              </span>
                              {parkSuggestions.map((suggestion, sIndex) => (
                                <span
                                  key={sIndex}
                                  className="park-quote-modal-suggestion-item"
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={() => {
                                    setParksentence(suggestion);
                                    setShowParkSuggestion(false);
                                  }}
                                >
                                  {suggestion}
                                </span>
                              ))}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="com-btn-outline com-btn"
                          data-bs-dismiss="modal"
                        >
                          {t("Cancel")}
                        </button>
                        <button
                          onClick={callpark}
                          disabled={parkSaving}
                          data-bs-dismiss="modal"
                          type="button"
                          className="com-btn"
                        >
                          {t("Save")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade park-quote-modal common-modal"
                  id="quoteModal"
                  tabIndex="-1"
                  aria-labelledby="quoteModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <h1 className="modal-title">{t("Add Note ?")}</h1>
                        <p className="park-quote-modal-para">
                          {t("Note for the order you want a quotation")}
                        </p>
                        <div className="placeholder-up-input">
                          <input
                            className="placeholder-up-input-field"
                            placeholder="The customer wants to quotation."
                            value={quatesentence}
                            onChange={(e) => setQuatesentence(e.target.value)}
                          />
                        </div>
                        <div className="park-quote-modal-date-area">
                          {t("Due Date")}
                          <span className="d-flex align-items-cente main-green-text">
                            <div className="main-body-row-right-col-inner-ct-top-inner-date-area-inner-input date">
                              <img
                                className="date-img"
                                src={
                                  base_assets +
                                  "images/icons/calendar-green.svg"
                                }
                                alt=""
                              />
                              <DatePicker
                                className="date-field"
                                selected={TransactionDate}
                                onChange={selectTransactionDate}
                                name="TransactionDate"
                                dateFormat={OrgSettings?.date_picker}
                                autoComplete="none"
                                popperPlacement="top-start"
                              />
                            </div>
                          </span>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="com-btn-outline com-btn"
                          data-bs-dismiss="modal"
                        >
                          {t("Cancel")}
                        </button>
                        {
                          <Link to="#">
                            <button
                              onClick={savequte}
                              type="button"
                              className="com-btn-outline com-btn"
                              data-bs-dismiss="modal"
                            >
                              {t("Save")}
                            </button>
                          </Link>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade common-modal"
                  id="checkoutorderrefoundModal"
                  tabIndex="-1"
                  aria-labelledby="checkoutModalLabel"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <img
                          className="modal-body-img common-modal-exclamation-img"
                          src={
                            base_assets +
                            "images/icons/exclamation-mark-green.png"
                          }
                          alt=""
                        />
                        <p className="modal-content-text">
                          {t("Do you want to refund ?")}
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn modal-content-no"
                          data-bs-dismiss="modal"
                        >
                          {t("No")}
                        </button>
                        {generalsettings?.data?.generalsetup
                          ?.Users_to_enter_PIN_for_every_sale === "1" ? (
                          <button
                            type="button"
                            className="btn modal-content-yes"
                            data-bs-toggle="modal"
                            data-bs-target="#pinModal"
                          >
                            {t("yes")}
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn modal-content-yes"
                            data-bs-toggle="modal"
                            data-bs-target="#pinModal"
                            onClick={
                              order_edit ? editcheckoutorder : ordercheckout
                            }
                          >
                            {t("yes")}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade common-modal"
                  id="checkoutorderModal"
                  tabIndex="-1"
                  aria-labelledby="checkoutModalLabel"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-body">
                        <img
                          className="modal-body-img common-modal-exclamation-img"
                          src={
                            base_assets +
                            "images/icons/exclamation-mark-green.png"
                          }
                          alt=""
                        />
                        <p className="modal-content-text">
                          {t("Do you want to Exchange ?")}
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn modal-content-no"
                          data-bs-dismiss="modal"
                        >
                          {t("No")}
                        </button>
                        {generalsettings?.data?.generalsetup
                          ?.Users_to_enter_PIN_for_every_sale === "1" ? (
                          <button
                            type="button"
                            className="btn modal-content-yes"
                            data-bs-toggle="modal"
                            data-bs-target="#pinModal"
                          >
                            {t("yes")}
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn modal-content-yes"
                            data-bs-toggle="modal"
                            data-bs-target="#pinModal"
                            onClick={
                              order_edit ? editcheckoutorder : ordercheckout
                            }
                          >
                            {t("yes")}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={
                    generalsettings?.data?.generalsetup
                      ?.Users_to_enter_PIN_for_every_sale === "0" &&
                      showorder === true
                      ? "common-modal pin-modal is-open"
                      : "modal fade common-modal pin-modal "
                  }
                  style={
                    generalsettings?.data?.generalsetup
                      ?.Users_to_enter_PIN_for_every_sale === "0" &&
                      showorder === true
                      ? { display: "block" }
                      : undefined
                  }
                  data-bs-backdrop="false"
                  id="pinModal"
                  tabIndex="-1"
                  aria-labelledby="pinModalLabel"
                >
                  {showorder ? (
                    <div
                      className="common-modal order-successful-modal d-block"
                      id="orderSuccessfulModal"
                    >
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-body">
                            <img
                              className="order-successful-modal-img"
                              src={
                                base_assets +
                                "images/pos/icons/check-success.png"
                              }
                              alt=""
                            />
                            <h5 className="order-successful-modal-heading">
                              {t("Order Successful")}
                            </h5>
                            <table className="order-successful-modal-table">
                              <tbody>
                                <tr>
                                  <td>{t("Order Summary")}</td>
                                  <td>
                                    {checkoutdetails?.count} {t("Item")}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td> {t("Grand Total")}</td>
                                  <td>
                                    <span>
                                      {" "}
                                      {toFormatPrice(
                                        checkoutdetails?.deposit_amount,
                                        { addSymbol: true }
                                      )}
                                    </span>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                            <div className="order-successful-modal-icons">
                              <a
                                className={
                                  parmissiondatashow?.pos_exchange?.Print
                                    ? "btn-style"
                                    : "d-none"
                                }
                                href={
                                  checkoutdetails?.url
                                    ? checkoutdetails?.url
                                    : "/app/pos/custom/custom"
                                }
                                target={"_blank"}
                                rel="noreferrer"
                              >
                                <img
                                  src={
                                    base_assets +
                                    "images/pos/icons/g-printer.png"
                                  }
                                  alt=""
                                />
                              </a>
                              <button
                                type="button"
                                className="btn-style"
                                onClick={openPosEmailModal}
                              >
                                <img
                                  src={
                                    base_assets + "images/pos/icons/g-msg.png"
                                  }
                                  alt=""
                                />
                              </button>
                              {/* <button className='btn-style'>
                              <img src={base_assets + "images/pos/icons/g-upload.png"} alt="" />
                            </button> */}
                            </div>
                            <Link
                              to="/app/pos/menu"
                              className="btn linear-bg order-successful-modal-btn"
                            >
                              {t("BACK TO POS")}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : generalsettings?.data?.generalsetup
                    ?.Users_to_enter_PIN_for_every_sale === "1" ? (
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <button
                          type="button"
                          className="btn-style close"
                          data-bs-dismiss="modal"
                        >
                          <img
                            src={
                              base_assets + "images/pos/icons/close-green.png"
                            }
                            alt=""
                          />
                        </button>
                        <div className="modal-body">
                          <h5 className="pin-modal-heading">
                            {t("Enter PIN")}
                          </h5>
                          <div
                            className={
                              "pin-modal-password active-" +
                              otpnumber?.length +
                              ""
                            }
                          >
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                            <span className="pin-modal-password-inner">
                              <span className="pin-modal-password-inner-dot"></span>
                            </span>
                          </div>
                          <button className="pin-modal-forgot btn-style">
                            {t("Forgot PIN")}
                          </button>
                          <div className="pin-modal-keys">
                            <div className="pin-modal-keys-row">
                              {[...new Array(10)].map((each, index) => {
                                return otpnumber?.length < 6 ? (
                                  <button
                                    className="btn-style pin-modal-keys-row-single"
                                    onClick={() => {
                                      setOtpnumber([
                                        ...otpnumber,
                                        index === 9 ? 0 : index + 1,
                                      ]);
                                    }}
                                    key={index}
                                  >
                                    {index === 9 ? 0 : index + 1}
                                  </button>
                                ) : (
                                  <button
                                    className="btn-style pin-modal-keys-row-single"
                                    key={index}
                                  >
                                    {index === 9 ? 0 : index + 1}
                                  </button>
                                );
                              })}
                            </div>
                            <button
                              className="btn-style clear"
                              onClick={() =>
                                setOtpnumber(otpnumber.slice(0, -1))
                              }
                            >
                              <img
                                src={
                                  base_assets + "images/pos/icons/clear-btn.png"
                                }
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {loader ? (
                  <div className="dot-loader-wrap">
                    <div className="dot-loader">
                      <div className="dot-loader-dot dot1"></div>
                      <div className="dot-loader-dot dot2"></div>
                      <div className="dot-loader-dot dot3"></div>
                      <div className="dot-loader-dot dot4"></div>
                      <div className="dot-loader-dot dot5"></div>
                      <div className="dot-loader-dot dot6"></div>
                      <div className="dot-loader-dot dot7"></div>
                      <div className="dot-loader-dot dot8"></div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <CustomerInformation cusid={cusid} setCusid={setCusid} />
                <EmailModal
                  type={ordertype}
                  email={checkoutdetails?.email}
                  id={checkoutdetails?.id}
                  setShoworder={setShoworder}
                />
              </>
            ) : showcheckout === "payment" ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_edit={state1?.order_edit}
                order_id={inv_orderid ? inv_orderid : state1?.order_id}
                order_type={"pos_order"}
              // by_custom_order={state1?.by_custom_order}
              // by_repair_order={by_repair_order}
              />
            ) : (
              <CheckoutBlank park_id={park_id} setpark_id={setpark_id} frompos={true} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Posscreen;
